const __vite__fileDeps=["./bundled-price-range.css","./bundled-customer-orders.css","./bundled-notifications.css","./bundled-copy-to-clipboard.css","./bundled-line-reveal.css","./bundled-reveal-img.css"],__vite__mapDeps=i=>i.map(i=>__vite__fileDeps[i]);
true&&(function polyfill() {
  const relList = document.createElement("link").relList;
  if (relList && relList.supports && relList.supports("modulepreload")) {
    return;
  }
  for (const link of document.querySelectorAll('link[rel="modulepreload"]')) {
    processPreload(link);
  }
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== "childList") {
        continue;
      }
      for (const node of mutation.addedNodes) {
        if (node.tagName === "LINK" && node.rel === "modulepreload")
          processPreload(node);
      }
    }
  }).observe(document, { childList: true, subtree: true });
  function getFetchOpts(link) {
    const fetchOpts = {};
    if (link.integrity) fetchOpts.integrity = link.integrity;
    if (link.referrerPolicy) fetchOpts.referrerPolicy = link.referrerPolicy;
    if (link.crossOrigin === "use-credentials")
      fetchOpts.credentials = "include";
    else if (link.crossOrigin === "anonymous") fetchOpts.credentials = "omit";
    else fetchOpts.credentials = "same-origin";
    return fetchOpts;
  }
  function processPreload(link) {
    if (link.ep)
      return;
    link.ep = true;
    const fetchOpts = getFetchOpts(link);
    fetch(link.href, fetchOpts);
  }
}());

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var ls_rias = {exports: {}};

var lazysizes = {exports: {}};

var hasRequiredLazysizes;

function requireLazysizes () {
	if (hasRequiredLazysizes) return lazysizes.exports;
	hasRequiredLazysizes = 1;
	(function (module) {
		(function(window, factory) {
			var lazySizes = factory(window, window.document, Date);
			window.lazySizes = lazySizes;
			if(module.exports){
				module.exports = lazySizes;
			}
		}(typeof window != 'undefined' ?
		      window : {}, 
		/**
		 * import("./types/global")
		 * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
		 */
		function l(window, document, Date) { // Pass in the window Date function also for SSR because the Date class can be lost
			/*jshint eqnull:true */

			var lazysizes,
				/**
				 * @type { LazySizesConfigPartial }
				 */
				lazySizesCfg;

			(function(){
				var prop;

				var lazySizesDefaults = {
					lazyClass: 'lazyload',
					loadedClass: 'lazyloaded',
					loadingClass: 'lazyloading',
					preloadClass: 'lazypreload',
					errorClass: 'lazyerror',
					//strictClass: 'lazystrict',
					autosizesClass: 'lazyautosizes',
					fastLoadedClass: 'ls-is-cached',
					iframeLoadMode: 0,
					srcAttr: 'data-src',
					srcsetAttr: 'data-srcset',
					sizesAttr: 'data-sizes',
					//preloadAfterLoad: false,
					minSize: 40,
					customMedia: {},
					init: true,
					expFactor: 1.5,
					hFac: 0.8,
					loadMode: 2,
					loadHidden: true,
					ricTimeout: 0,
					throttleDelay: 125,
				};

				lazySizesCfg = window.lazySizesConfig || window.lazysizesConfig || {};

				for(prop in lazySizesDefaults){
					if(!(prop in lazySizesCfg)){
						lazySizesCfg[prop] = lazySizesDefaults[prop];
					}
				}
			})();

			if (!document || !document.getElementsByClassName) {
				return {
					init: function () {},
					/**
					 * @type { LazySizesConfigPartial }
					 */
					cfg: lazySizesCfg,
					/**
					 * @type { true }
					 */
					noSupport: true,
				};
			}

			var docElem = document.documentElement;

			var supportPicture = window.HTMLPictureElement;

			var _addEventListener = 'addEventListener';

			var _getAttribute = 'getAttribute';

			/**
			 * Update to bind to window because 'this' becomes null during SSR
			 * builds.
			 */
			var addEventListener = window[_addEventListener].bind(window);

			var setTimeout = window.setTimeout;

			var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

			var requestIdleCallback = window.requestIdleCallback;

			var regPicture = /^picture$/i;

			var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

			var regClassCache = {};

			var forEach = Array.prototype.forEach;

			/**
			 * @param ele {Element}
			 * @param cls {string}
			 */
			var hasClass = function(ele, cls) {
				if(!regClassCache[cls]){
					regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
				}
				return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
			};

			/**
			 * @param ele {Element}
			 * @param cls {string}
			 */
			var addClass = function(ele, cls) {
				if (!hasClass(ele, cls)){
					ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
				}
			};

			/**
			 * @param ele {Element}
			 * @param cls {string}
			 */
			var removeClass = function(ele, cls) {
				var reg;
				if ((reg = hasClass(ele,cls))) {
					ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
				}
			};

			var addRemoveLoadEvents = function(dom, fn, add){
				var action = add ? _addEventListener : 'removeEventListener';
				if(add){
					addRemoveLoadEvents(dom, fn);
				}
				loadEvents.forEach(function(evt){
					dom[action](evt, fn);
				});
			};

			/**
			 * @param elem { Element }
			 * @param name { string }
			 * @param detail { any }
			 * @param noBubbles { boolean }
			 * @param noCancelable { boolean }
			 * @returns { CustomEvent }
			 */
			var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
				var event = document.createEvent('Event');

				if(!detail){
					detail = {};
				}

				detail.instance = lazysizes;

				event.initEvent(name, !noBubbles, !noCancelable);

				event.detail = detail;

				elem.dispatchEvent(event);
				return event;
			};

			var updatePolyfill = function (el, full){
				var polyfill;
				if( !supportPicture && ( polyfill = (window.picturefill || lazySizesCfg.pf) ) ){
					if(full && full.src && !el[_getAttribute]('srcset')){
						el.setAttribute('srcset', full.src);
					}
					polyfill({reevaluate: true, elements: [el]});
				} else if(full && full.src){
					el.src = full.src;
				}
			};

			var getCSS = function (elem, style){
				return (getComputedStyle(elem, null) || {})[style];
			};

			/**
			 *
			 * @param elem { Element }
			 * @param parent { Element }
			 * @param [width] {number}
			 * @returns {number}
			 */
			var getWidth = function(elem, parent, width){
				width = width || elem.offsetWidth;

				while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
					width =  parent.offsetWidth;
					parent = parent.parentNode;
				}

				return width;
			};

			var rAF = (function(){
				var running, waiting;
				var firstFns = [];
				var secondFns = [];
				var fns = firstFns;

				var run = function(){
					var runFns = fns;

					fns = firstFns.length ? secondFns : firstFns;

					running = true;
					waiting = false;

					while(runFns.length){
						runFns.shift()();
					}

					running = false;
				};

				var rafBatch = function(fn, queue){
					if(running && !queue){
						fn.apply(this, arguments);
					} else {
						fns.push(fn);

						if(!waiting){
							waiting = true;
							(document.hidden ? setTimeout : requestAnimationFrame)(run);
						}
					}
				};

				rafBatch._lsFlush = run;

				return rafBatch;
			})();

			var rAFIt = function(fn, simple){
				return simple ?
					function() {
						rAF(fn);
					} :
					function(){
						var that = this;
						var args = arguments;
						rAF(function(){
							fn.apply(that, args);
						});
					}
				;
			};

			var throttle = function(fn){
				var running;
				var lastTime = 0;
				var gDelay = lazySizesCfg.throttleDelay;
				var rICTimeout = lazySizesCfg.ricTimeout;
				var run = function(){
					running = false;
					lastTime = Date.now();
					fn();
				};
				var idleCallback = requestIdleCallback && rICTimeout > 49 ?
					function(){
						requestIdleCallback(run, {timeout: rICTimeout});

						if(rICTimeout !== lazySizesCfg.ricTimeout){
							rICTimeout = lazySizesCfg.ricTimeout;
						}
					} :
					rAFIt(function(){
						setTimeout(run);
					}, true)
				;

				return function(isPriority){
					var delay;

					if((isPriority = isPriority === true)){
						rICTimeout = 33;
					}

					if(running){
						return;
					}

					running =  true;

					delay = gDelay - (Date.now() - lastTime);

					if(delay < 0){
						delay = 0;
					}

					if(isPriority || delay < 9){
						idleCallback();
					} else {
						setTimeout(idleCallback, delay);
					}
				};
			};

			//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
			var debounce = function(func) {
				var timeout, timestamp;
				var wait = 99;
				var run = function(){
					timeout = null;
					func();
				};
				var later = function() {
					var last = Date.now() - timestamp;

					if (last < wait) {
						setTimeout(later, wait - last);
					} else {
						(requestIdleCallback || run)(run);
					}
				};

				return function() {
					timestamp = Date.now();

					if (!timeout) {
						timeout = setTimeout(later, wait);
					}
				};
			};

			var loader = (function(){
				var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

				var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;

				var regImg = /^img$/i;
				var regIframe = /^iframe$/i;

				var supportScroll = ('onscroll' in window) && !(/(gle|ing)bot/.test(navigator.userAgent));

				var shrinkExpand = 0;
				var currentExpand = 0;

				var isLoading = 0;
				var lowRuns = -1;

				var resetPreloading = function(e){
					isLoading--;
					if(!e || isLoading < 0 || !e.target){
						isLoading = 0;
					}
				};

				var isVisible = function (elem) {
					if (isBodyHidden == null) {
						isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
					}

					return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
				};

				var isNestedVisible = function(elem, elemExpand){
					var outerRect;
					var parent = elem;
					var visible = isVisible(elem);

					eLtop -= elemExpand;
					eLbottom += elemExpand;
					eLleft -= elemExpand;
					eLright += elemExpand;

					while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
						visible = ((getCSS(parent, 'opacity') || 1) > 0);

						if(visible && getCSS(parent, 'overflow') != 'visible'){
							outerRect = parent.getBoundingClientRect();
							visible = eLright > outerRect.left &&
								eLleft < outerRect.right &&
								eLbottom > outerRect.top - 1 &&
								eLtop < outerRect.bottom + 1
							;
						}
					}

					return visible;
				};

				var checkElements = function() {
					var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal,
						beforeExpandVal, defaultExpand, preloadExpand, hFac;
					var lazyloadElems = lazysizes.elements;

					if((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){

						i = 0;

						lowRuns++;

						for(; i < eLlen; i++){

							if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}

							if(!supportScroll || (lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i]))){unveilElement(lazyloadElems[i]);continue;}

							if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
								elemExpand = currentExpand;
							}

							if (!defaultExpand) {
								defaultExpand = (!lazySizesCfg.expand || lazySizesCfg.expand < 1) ?
									docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 :
									lazySizesCfg.expand;

								lazysizes._defEx = defaultExpand;

								preloadExpand = defaultExpand * lazySizesCfg.expFactor;
								hFac = lazySizesCfg.hFac;
								isBodyHidden = null;

								if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
									currentExpand = preloadExpand;
									lowRuns = 0;
								} else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
									currentExpand = defaultExpand;
								} else {
									currentExpand = shrinkExpand;
								}
							}

							if(beforeExpandVal !== elemExpand){
								eLvW = innerWidth + (elemExpand * hFac);
								elvH = innerHeight + elemExpand;
								elemNegativeExpand = elemExpand * -1;
								beforeExpandVal = elemExpand;
							}

							rect = lazyloadElems[i].getBoundingClientRect();

							if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
								(eLtop = rect.top) <= elvH &&
								(eLright = rect.right) >= elemNegativeExpand * hFac &&
								(eLleft = rect.left) <= eLvW &&
								(eLbottom || eLright || eLleft || eLtop) &&
								(lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) &&
								((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
								unveilElement(lazyloadElems[i]);
								loadedSomething = true;
								if(isLoading > 9){break;}
							} else if(!loadedSomething && isCompleted && !autoLoadElem &&
								isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
								(preloadElems[0] || lazySizesCfg.preloadAfterLoad) &&
								(preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto')))){
								autoLoadElem = preloadElems[0] || lazyloadElems[i];
							}
						}

						if(autoLoadElem && !loadedSomething){
							unveilElement(autoLoadElem);
						}
					}
				};

				var throttledCheckElements = throttle(checkElements);

				var switchLoadingClass = function(e){
					var elem = e.target;

					if (elem._lazyCache) {
						delete elem._lazyCache;
						return;
					}

					resetPreloading(e);
					addClass(elem, lazySizesCfg.loadedClass);
					removeClass(elem, lazySizesCfg.loadingClass);
					addRemoveLoadEvents(elem, rafSwitchLoadingClass);
					triggerEvent(elem, 'lazyloaded');
				};
				var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
				var rafSwitchLoadingClass = function(e){
					rafedSwitchLoadingClass({target: e.target});
				};

				var changeIframeSrc = function(elem, src){
					var loadMode = elem.getAttribute('data-load-mode') || lazySizesCfg.iframeLoadMode;

					// loadMode can be also a string!
					if (loadMode == 0) {
						elem.contentWindow.location.replace(src);
					} else if (loadMode == 1) {
						elem.src = src;
					}
				};

				var handleSources = function(source){
					var customMedia;

					var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);

					if( (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
						source.setAttribute('media', customMedia);
					}

					if(sourceSrcset){
						source.setAttribute('srcset', sourceSrcset);
					}
				};

				var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
					var src, srcset, parent, isPicture, event, firesLoad;

					if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){

						if(sizes){
							if(isAuto){
								addClass(elem, lazySizesCfg.autosizesClass);
							} else {
								elem.setAttribute('sizes', sizes);
							}
						}

						srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
						src = elem[_getAttribute](lazySizesCfg.srcAttr);

						if(isImg) {
							parent = elem.parentNode;
							isPicture = parent && regPicture.test(parent.nodeName || '');
						}

						firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));

						event = {target: elem};

						addClass(elem, lazySizesCfg.loadingClass);

						if(firesLoad){
							clearTimeout(resetPreloadingTimer);
							resetPreloadingTimer = setTimeout(resetPreloading, 2500);
							addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
						}

						if(isPicture){
							forEach.call(parent.getElementsByTagName('source'), handleSources);
						}

						if(srcset){
							elem.setAttribute('srcset', srcset);
						} else if(src && !isPicture){
							if(regIframe.test(elem.nodeName)){
								changeIframeSrc(elem, src);
							} else {
								elem.src = src;
							}
						}

						if(isImg && (srcset || isPicture)){
							updatePolyfill(elem, {src: src});
						}
					}

					if(elem._lazyRace){
						delete elem._lazyRace;
					}
					removeClass(elem, lazySizesCfg.lazyClass);

					rAF(function(){
						// Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
						var isLoaded = elem.complete && elem.naturalWidth > 1;

						if( !firesLoad || isLoaded){
							if (isLoaded) {
								addClass(elem, lazySizesCfg.fastLoadedClass);
							}
							switchLoadingClass(event);
							elem._lazyCache = true;
							setTimeout(function(){
								if ('_lazyCache' in elem) {
									delete elem._lazyCache;
								}
							}, 9);
						}
						if (elem.loading == 'lazy') {
							isLoading--;
						}
					}, true);
				});

				/**
				 *
				 * @param elem { Element }
				 */
				var unveilElement = function (elem){
					if (elem._lazyRace) {return;}
					var detail;

					var isImg = regImg.test(elem.nodeName);

					//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
					var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
					var isAuto = sizes == 'auto';

					if( (isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)){return;}

					detail = triggerEvent(elem, 'lazyunveilread').detail;

					if(isAuto){
						 autoSizer.updateElem(elem, true, elem.offsetWidth);
					}

					elem._lazyRace = true;
					isLoading++;

					lazyUnveil(elem, detail, isAuto, sizes, isImg);
				};

				var afterScroll = debounce(function(){
					lazySizesCfg.loadMode = 3;
					throttledCheckElements();
				});

				var altLoadmodeScrollListner = function(){
					if(lazySizesCfg.loadMode == 3){
						lazySizesCfg.loadMode = 2;
					}
					afterScroll();
				};

				var onload = function(){
					if(isCompleted){return;}
					if(Date.now() - started < 999){
						setTimeout(onload, 999);
						return;
					}


					isCompleted = true;

					lazySizesCfg.loadMode = 3;

					throttledCheckElements();

					addEventListener('scroll', altLoadmodeScrollListner, true);
				};

				return {
					_: function(){
						started = Date.now();

						lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
						preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);

						addEventListener('scroll', throttledCheckElements, true);

						addEventListener('resize', throttledCheckElements, true);

						addEventListener('pageshow', function (e) {
							if (e.persisted) {
								var loadingElements = document.querySelectorAll('.' + lazySizesCfg.loadingClass);

								if (loadingElements.length && loadingElements.forEach) {
									requestAnimationFrame(function () {
										loadingElements.forEach( function (img) {
											if (img.complete) {
												unveilElement(img);
											}
										});
									});
								}
							}
						});

						if(window.MutationObserver){
							new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
						} else {
							docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
							docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
							setInterval(throttledCheckElements, 999);
						}

						addEventListener('hashchange', throttledCheckElements, true);

						//, 'fullscreenchange'
						['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend'].forEach(function(name){
							document[_addEventListener](name, throttledCheckElements, true);
						});

						if((/d$|^c/.test(document.readyState))){
							onload();
						} else {
							addEventListener('load', onload);
							document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
							setTimeout(onload, 20000);
						}

						if(lazysizes.elements.length){
							checkElements();
							rAF._lsFlush();
						} else {
							throttledCheckElements();
						}
					},
					checkElems: throttledCheckElements,
					unveil: unveilElement,
					_aLSL: altLoadmodeScrollListner,
				};
			})();


			var autoSizer = (function(){
				var autosizesElems;

				var sizeElement = rAFIt(function(elem, parent, event, width){
					var sources, i, len;
					elem._lazysizesWidth = width;
					width += 'px';

					elem.setAttribute('sizes', width);

					if(regPicture.test(parent.nodeName || '')){
						sources = parent.getElementsByTagName('source');
						for(i = 0, len = sources.length; i < len; i++){
							sources[i].setAttribute('sizes', width);
						}
					}

					if(!event.detail.dataAttr){
						updatePolyfill(elem, event.detail);
					}
				});
				/**
				 *
				 * @param elem {Element}
				 * @param dataAttr
				 * @param [width] { number }
				 */
				var getSizeElement = function (elem, dataAttr, width){
					var event;
					var parent = elem.parentNode;

					if(parent){
						width = getWidth(elem, parent, width);
						event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});

						if(!event.defaultPrevented){
							width = event.detail.width;

							if(width && width !== elem._lazysizesWidth){
								sizeElement(elem, parent, event, width);
							}
						}
					}
				};

				var updateElementsSizes = function(){
					var i;
					var len = autosizesElems.length;
					if(len){
						i = 0;

						for(; i < len; i++){
							getSizeElement(autosizesElems[i]);
						}
					}
				};

				var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

				return {
					_: function(){
						autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
						addEventListener('resize', debouncedUpdateElementsSizes);
					},
					checkElems: debouncedUpdateElementsSizes,
					updateElem: getSizeElement
				};
			})();

			var init = function(){
				if(!init.i && document.getElementsByClassName){
					init.i = true;
					autoSizer._();
					loader._();
				}
			};

			setTimeout(function(){
				if(lazySizesCfg.init){
					init();
				}
			});

			lazysizes = {
				/**
				 * @type { LazySizesConfigPartial }
				 */
				cfg: lazySizesCfg,
				autoSizer: autoSizer,
				loader: loader,
				init: init,
				uP: updatePolyfill,
				aC: addClass,
				rC: removeClass,
				hC: hasClass,
				fire: triggerEvent,
				gW: getWidth,
				rAF: rAF,
			};

			return lazysizes;
		}
		)); 
	} (lazysizes));
	return lazysizes.exports;
}

(function (module) {
	(function(window, factory) {
		var globalInstall = function(){
			factory(window.lazySizes);
			window.removeEventListener('lazyunveilread', globalInstall, true);
		};

		factory = factory.bind(null, window, window.document);

		if(module.exports){
			factory(requireLazysizes());
		} else if(window.lazySizes) {
			globalInstall();
		} else {
			window.addEventListener('lazyunveilread', globalInstall, true);
		}
	}(window, function(window, document, lazySizes) {

		var config, riasCfg;
		var lazySizesCfg = lazySizes.cfg;
		var replaceTypes = {string: 1, number: 1};
		var regNumber = /^\-*\+*\d+\.*\d*$/;
		var regPicture = /^picture$/i;
		var regWidth = /\s*\{\s*width\s*\}\s*/i;
		var regHeight = /\s*\{\s*height\s*\}\s*/i;
		var regPlaceholder = /\s*\{\s*([a-z0-9]+)\s*\}\s*/ig;
		var regObj = /^\[.*\]|\{.*\}$/;
		var regAllowedSizes = /^(?:auto|\d+(px)?)$/;
		var anchor = document.createElement('a');
		var img = document.createElement('img');
		var buggySizes = ('srcset' in img) && !('sizes' in img);
		var supportPicture = !!window.HTMLPictureElement && !buggySizes;

		(function(){
			var prop;
			var noop = function(){};
			var riasDefaults = {
				prefix: '',
				postfix: '',
				srcAttr: 'data-src',
				absUrl: false,
				modifyOptions: noop,
				widthmap: {},
				ratio: false,
				traditionalRatio: false,
				aspectratio: false,
			};

			config = lazySizes && lazySizes.cfg;

			if(!config.supportsType){
				config.supportsType = function(type/*, elem*/){
					return !type;
				};
			}

			if(!config.rias){
				config.rias = {};
			}
			riasCfg = config.rias;

			if(!('widths' in riasCfg)){
				riasCfg.widths = [];
				(function (widths){
					var width;
					var i = 0;
					while(!width || width < 3000){
						i += 5;
						if(i > 30){
							i += 1;
						}
						width = (36 * i);
						widths.push(width);
					}
				})(riasCfg.widths);
			}

			for(prop in riasDefaults){
				if(!(prop in riasCfg)){
					riasCfg[prop] = riasDefaults[prop];
				}
			}
		})();

		function getElementOptions(elem, src, options){
			var attr, parent, setOption, prop, opts;
			var elemStyles = window.getComputedStyle(elem);

			if (!options) {
				parent = elem.parentNode;

				options = {
					isPicture: !!(parent && regPicture.test(parent.nodeName || ''))
				};
			} else {
				opts = {};

				for (prop in options) {
					opts[prop] = options[prop];
				}

				options = opts;
			}

			setOption = function(attr, run){
				var attrVal = elem.getAttribute('data-'+ attr);

				if (!attrVal) {
					// no data- attr, get value from the CSS
					var styles = elemStyles.getPropertyValue('--ls-' + attr);
					// at least Safari 9 returns null rather than
					// an empty string for getPropertyValue causing
					// .trim() to fail
					if (styles) {
						attrVal = styles.trim();
					}
				}

				if (attrVal) {
					if(attrVal == 'true'){
						attrVal = true;
					} else if(attrVal == 'false'){
						attrVal = false;
					} else if(regNumber.test(attrVal)){
						attrVal = parseFloat(attrVal);
					} else if(typeof riasCfg[attr] == 'function'){
						attrVal = riasCfg[attr](elem, attrVal);
					} else if(regObj.test(attrVal)){
						try {
							attrVal = JSON.parse(attrVal);
						} catch(e){}
					}
					options[attr] = attrVal;
				} else if((attr in riasCfg) && typeof riasCfg[attr] != 'function' && !options[attr]){
					options[attr] = riasCfg[attr];
				} else if(run && typeof riasCfg[attr] == 'function'){
					options[attr] = riasCfg[attr](elem, attrVal);
				}
			};

			for(attr in riasCfg){
				setOption(attr);
			}
			src.replace(regPlaceholder, function(full, match){
				if(!(match in options)){
					setOption(match, true);
				}
			});

			return options;
		}

		function replaceUrlProps(url, options){
			var candidates = [];
			var replaceFn = function(full, match){
				return (replaceTypes[typeof options[match]]) ? options[match] : full;
			};
			candidates.srcset = [];

			if(options.absUrl){
				anchor.setAttribute('href', url);
				url = anchor.href;
			}

			url = ((options.prefix || '') + url + (options.postfix || '')).replace(regPlaceholder, replaceFn);

			options.widths.forEach(function(width){
				var widthAlias = options.widthmap[width] || width;
				var ratio = options.aspectratio || options.ratio;
				var traditionalRatio = !options.aspectratio && riasCfg.traditionalRatio;
				var candidate = {
					u: url.replace(regWidth, widthAlias)
							.replace(regHeight, ratio ?
								traditionalRatio ?
									Math.round(width * ratio) :
									Math.round(width / ratio)
								: ''),
					w: width
				};

				candidates.push(candidate);
				candidates.srcset.push( (candidate.c = candidate.u + ' ' + width + 'w') );
			});
			return candidates;
		}

		function setSrc(src, opts, elem){
			var elemW = 0;
			var elemH = 0;
			var sizeElement = elem;

			if(!src){return;}

			if (opts.ratio === 'container') {
				// calculate image or parent ratio
				elemW = sizeElement.scrollWidth;
				elemH = sizeElement.scrollHeight;

				while ((!elemW || !elemH) && sizeElement !== document) {
					sizeElement = sizeElement.parentNode;
					elemW = sizeElement.scrollWidth;
					elemH = sizeElement.scrollHeight;
				}
				if (elemW && elemH) {
					opts.ratio = opts.traditionalRatio ? elemH / elemW : elemW / elemH;
				}
			}

			src = replaceUrlProps(src, opts);

			src.isPicture = opts.isPicture;

			if(buggySizes && elem.nodeName.toUpperCase() == 'IMG'){
				elem.removeAttribute(config.srcsetAttr);
			} else {
				elem.setAttribute(config.srcsetAttr, src.srcset.join(', '));
			}

			Object.defineProperty(elem, '_lazyrias', {
				value: src,
				writable: true
			});
		}

		function createAttrObject(elem, src){
			var opts = getElementOptions(elem, src);

			riasCfg.modifyOptions.call(elem, {target: elem, details: opts, detail: opts});

			lazySizes.fire(elem, 'lazyriasmodifyoptions', opts);
			return opts;
		}

		function getSrc(elem){
			return elem.getAttribute( elem.getAttribute('data-srcattr') || riasCfg.srcAttr ) || elem.getAttribute(config.srcsetAttr) || elem.getAttribute(config.srcAttr) || elem.getAttribute('data-pfsrcset') || '';
		}

		addEventListener('lazybeforesizes', function(e){
			if(e.detail.instance != lazySizes){return;}

			var elem, src, elemOpts, sourceOpts, parent, sources, i, len, sourceSrc, sizes, detail, hasPlaceholder, modified, emptyList;
			elem = e.target;

			if(!e.detail.dataAttr || e.defaultPrevented || riasCfg.disabled || !((sizes = elem.getAttribute(config.sizesAttr) || elem.getAttribute('sizes')) && regAllowedSizes.test(sizes))){return;}

			src = getSrc(elem);

			elemOpts = createAttrObject(elem, src);

			hasPlaceholder = regWidth.test(elemOpts.prefix) || regWidth.test(elemOpts.postfix);

			if(elemOpts.isPicture && (parent = elem.parentNode)){
				sources = parent.getElementsByTagName('source');
				for(i = 0, len = sources.length; i < len; i++){
					if ( hasPlaceholder || regWidth.test(sourceSrc = getSrc(sources[i])) ){
						sourceOpts = getElementOptions(sources[i], sourceSrc, elemOpts);
						setSrc(sourceSrc, sourceOpts, sources[i]);
						modified = true;
					}
				}
			}

			if ( hasPlaceholder || regWidth.test(src) ){
				setSrc(src, elemOpts, elem);
				modified = true;
			} else if (modified) {
				emptyList = [];
				emptyList.srcset = [];
				emptyList.isPicture = true;
				Object.defineProperty(elem, '_lazyrias', {
					value: emptyList,
					writable: true
				});
			}

			if(modified){
				if(supportPicture){
					elem.removeAttribute(config.srcAttr);
				} else if(sizes != 'auto') {
					detail = {
						width: parseInt(sizes, 10)
					};
					polyfill({
						target: elem,
						detail: detail
					});
				}
			}
		}, true);
		// partial polyfill
		var polyfill = (function(){
			var ascendingSort = function( a, b ) {
				return a.w - b.w;
			};

			var reduceCandidate = function (srces) {
				var lowerCandidate, bonusFactor;
				var len = srces.length;
				var candidate = srces[len -1];
				var i = 0;

				for(i; i < len;i++){
					candidate = srces[i];
					candidate.d = candidate.w / srces.w;
					if(candidate.d >= srces.d){
						if(!candidate.cached && (lowerCandidate = srces[i - 1]) &&
							lowerCandidate.d > srces.d - (0.13 * Math.pow(srces.d, 2.2))){

							bonusFactor = Math.pow(lowerCandidate.d - 0.6, 1.6);

							if(lowerCandidate.cached) {
								lowerCandidate.d += 0.15 * bonusFactor;
							}

							if(lowerCandidate.d + ((candidate.d - srces.d) * bonusFactor) > srces.d){
								candidate = lowerCandidate;
							}
						}
						break;
					}
				}
				return candidate;
			};

			var getWSet = function(elem, testPicture){
				var src;
				if(!elem._lazyrias && lazySizes.pWS && (src = lazySizes.pWS(elem.getAttribute(config.srcsetAttr || ''))).length){
					Object.defineProperty(elem, '_lazyrias', {
						value: src,
						writable: true
					});
					if(testPicture && elem.parentNode){
						src.isPicture = elem.parentNode.nodeName.toUpperCase() == 'PICTURE';
					}
				}
				return elem._lazyrias;
			};

			var getX = function(elem){
				var dpr = window.devicePixelRatio || 1;
				var optimum = lazySizes.getX && lazySizes.getX(elem);
				return Math.min(optimum || dpr, 2.4, dpr);
			};

			var getCandidate = function(elem, width){
				var sources, i, len, media, srces, src;

				srces = elem._lazyrias;

				if(srces.isPicture && window.matchMedia){
					for(i = 0, sources = elem.parentNode.getElementsByTagName('source'), len = sources.length; i < len; i++){
						if(getWSet(sources[i]) && !sources[i].getAttribute('type') && ( !(media = sources[i].getAttribute('media')) || ((matchMedia(media) || {}).matches))){
							srces = sources[i]._lazyrias;
							break;
						}
					}
				}

				if(!srces.w || srces.w < width){
					srces.w = width;
					srces.d = getX(elem);
					src = reduceCandidate(srces.sort(ascendingSort));
				}

				return src;
			};

			var polyfill = function(e){
				if(e.detail.instance != lazySizes){return;}

				var candidate;
				var elem = e.target;

				if(!buggySizes && (window.respimage || window.picturefill || lazySizesCfg.pf)){
					document.removeEventListener('lazybeforesizes', polyfill);
					return;
				}

				if(!('_lazyrias' in elem) && (!e.detail.dataAttr || !getWSet(elem, true))){
					return;
				}

				candidate = getCandidate(elem, e.detail.width);

				if(candidate && candidate.u && elem._lazyrias.cur != candidate.u){
					elem._lazyrias.cur = candidate.u;
					candidate.cached = true;
					lazySizes.rAF(function(){
						elem.setAttribute(config.srcAttr, candidate.u);
						elem.setAttribute('src', candidate.u);
					});
				}
			};

			if(!supportPicture){
				addEventListener('lazybeforesizes', polyfill);
			} else {
				polyfill = function(){};
			}

			return polyfill;

		})();

	})); 
} (ls_rias));

class Deferrer{constructor(){this.hasFulfilled=!1,this.promise=new Promise((s,e)=>{this.resolve=s,this.reject=e;}),this.promise.then(()=>this.hasFulfilled=!0).catch(()=>this.hasFulfilled=!0);}}

function generateRdmString$1({length:e=8,chars:t="ABCDEFabcdef0123456789"}={}){let r="";for(let n=0;n<e;n++){let e=~~(Math.random()*t.length);r+=t.charAt(e);}return r}function pluralize(e=0,t,r){return r||(r=t+"s"),e<=1?t:r}function toHyphenCase(e){return e.replace(/[A-Z]/g,(e,t)=>(t>0?"-":"")+e.toLowerCase())}

class DirectiveHost{get host(){return this._host}get directives(){return this._directives}applyToDirectives(t){for(let e=0;e<this.directives.length;e++)t(this.directives[e],e);}emitChange(){for(let t=0;t<this.directives.length;t++)this.directives[t].__onAppChange(),this.directives[t].onAppChange();}getDirectiveByConstructor(t){for(let e=0;e<this.directives.length;e++){let i=this.directives[e];if(i instanceof t)return i}return null}hasDirectiveFrom(t){for(let e=0;e<this.directives.length;e++)if(this.directives[e]instanceof t)return !0;return !1}constructor(t,e=[]){this._host=t,this._directives=e;}}

/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var Reflect$1;
(function (Reflect) {
    // Metadata Proposal
    // https://rbuckton.github.io/reflect-metadata/
    (function (factory) {
        var root = typeof commonjsGlobal === "object" ? commonjsGlobal :
            typeof self === "object" ? self :
                typeof this === "object" ? this :
                    Function("return this;")();
        var exporter = makeExporter(Reflect);
        if (typeof root.Reflect === "undefined") {
            root.Reflect = Reflect;
        }
        else {
            exporter = makeExporter(root.Reflect, exporter);
        }
        factory(exporter);
        function makeExporter(target, previous) {
            return function (key, value) {
                if (typeof target[key] !== "function") {
                    Object.defineProperty(target, key, { configurable: true, writable: true, value: value });
                }
                if (previous)
                    previous(key, value);
            };
        }
    })(function (exporter) {
        var hasOwn = Object.prototype.hasOwnProperty;
        // feature test for Symbol support
        var supportsSymbol = typeof Symbol === "function";
        var toPrimitiveSymbol = supportsSymbol && typeof Symbol.toPrimitive !== "undefined" ? Symbol.toPrimitive : "@@toPrimitive";
        var iteratorSymbol = supportsSymbol && typeof Symbol.iterator !== "undefined" ? Symbol.iterator : "@@iterator";
        var supportsCreate = typeof Object.create === "function"; // feature test for Object.create support
        var supportsProto = { __proto__: [] } instanceof Array; // feature test for __proto__ support
        var downLevel = !supportsCreate && !supportsProto;
        var HashMap = {
            // create an object in dictionary mode (a.k.a. "slow" mode in v8)
            create: supportsCreate
                ? function () { return MakeDictionary(Object.create(null)); }
                : supportsProto
                    ? function () { return MakeDictionary({ __proto__: null }); }
                    : function () { return MakeDictionary({}); },
            has: downLevel
                ? function (map, key) { return hasOwn.call(map, key); }
                : function (map, key) { return key in map; },
            get: downLevel
                ? function (map, key) { return hasOwn.call(map, key) ? map[key] : undefined; }
                : function (map, key) { return map[key]; },
        };
        // Load global or shim versions of Map, Set, and WeakMap
        var functionPrototype = Object.getPrototypeOf(Function);
        var usePolyfill = typeof process === "object" && process["env" + ""] && process["env" + ""]["REFLECT_METADATA_USE_MAP_POLYFILL"] === "true";
        var _Map = !usePolyfill && typeof Map === "function" && typeof Map.prototype.entries === "function" ? Map : CreateMapPolyfill();
        var _Set = !usePolyfill && typeof Set === "function" && typeof Set.prototype.entries === "function" ? Set : CreateSetPolyfill();
        var _WeakMap = !usePolyfill && typeof WeakMap === "function" ? WeakMap : CreateWeakMapPolyfill();
        // [[Metadata]] internal slot
        // https://rbuckton.github.io/reflect-metadata/#ordinary-object-internal-methods-and-internal-slots
        var Metadata = new _WeakMap();
        /**
         * Applies a set of decorators to a property of a target object.
         * @param decorators An array of decorators.
         * @param target The target object.
         * @param propertyKey (Optional) The property key to decorate.
         * @param attributes (Optional) The property descriptor for the target key.
         * @remarks Decorators are applied in reverse order.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Example = Reflect.decorate(decoratorsArray, Example);
         *
         *     // property (on constructor)
         *     Reflect.decorate(decoratorsArray, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.decorate(decoratorsArray, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Object.defineProperty(Example, "staticMethod",
         *         Reflect.decorate(decoratorsArray, Example, "staticMethod",
         *             Object.getOwnPropertyDescriptor(Example, "staticMethod")));
         *
         *     // method (on prototype)
         *     Object.defineProperty(Example.prototype, "method",
         *         Reflect.decorate(decoratorsArray, Example.prototype, "method",
         *             Object.getOwnPropertyDescriptor(Example.prototype, "method")));
         *
         */
        function decorate(decorators, target, propertyKey, attributes) {
            if (!IsUndefined(propertyKey)) {
                if (!IsArray(decorators))
                    throw new TypeError();
                if (!IsObject(target))
                    throw new TypeError();
                if (!IsObject(attributes) && !IsUndefined(attributes) && !IsNull(attributes))
                    throw new TypeError();
                if (IsNull(attributes))
                    attributes = undefined;
                propertyKey = ToPropertyKey(propertyKey);
                return DecorateProperty(decorators, target, propertyKey, attributes);
            }
            else {
                if (!IsArray(decorators))
                    throw new TypeError();
                if (!IsConstructor(target))
                    throw new TypeError();
                return DecorateConstructor(decorators, target);
            }
        }
        exporter("decorate", decorate);
        // 4.1.2 Reflect.metadata(metadataKey, metadataValue)
        // https://rbuckton.github.io/reflect-metadata/#reflect.metadata
        /**
         * A default metadata decorator factory that can be used on a class, class member, or parameter.
         * @param metadataKey The key for the metadata entry.
         * @param metadataValue The value for the metadata entry.
         * @returns A decorator function.
         * @remarks
         * If `metadataKey` is already defined for the target and target key, the
         * metadataValue for that key will be overwritten.
         * @example
         *
         *     // constructor
         *     @Reflect.metadata(key, value)
         *     class Example {
         *     }
         *
         *     // property (on constructor, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticProperty;
         *     }
         *
         *     // property (on prototype, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         property;
         *     }
         *
         *     // method (on constructor)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticMethod() { }
         *     }
         *
         *     // method (on prototype)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         method() { }
         *     }
         *
         */
        function metadata(metadataKey, metadataValue) {
            function decorator(target, propertyKey) {
                if (!IsObject(target))
                    throw new TypeError();
                if (!IsUndefined(propertyKey) && !IsPropertyKey(propertyKey))
                    throw new TypeError();
                OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
            }
            return decorator;
        }
        exporter("metadata", metadata);
        /**
         * Define a unique metadata entry on the target.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param metadataValue A value that contains attached metadata.
         * @param target The target object on which to define metadata.
         * @param propertyKey (Optional) The property key for the target.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Reflect.defineMetadata("custom:annotation", options, Example);
         *
         *     // property (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticMethod");
         *
         *     // method (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "method");
         *
         *     // decorator factory as metadata-producing annotation.
         *     function MyAnnotation(options): Decorator {
         *         return (target, key?) => Reflect.defineMetadata("custom:annotation", options, target, key);
         *     }
         *
         */
        function defineMetadata(metadataKey, metadataValue, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
        }
        exporter("defineMetadata", defineMetadata);
        /**
         * Gets a value indicating whether the target object or its prototype chain has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object or its prototype chain; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function hasMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasMetadata", hasMetadata);
        /**
         * Gets a value indicating whether the target object has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function hasOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasOwnMetadata", hasOwnMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object or its prototype chain.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function getMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetMetadata(metadataKey, target, propertyKey);
        }
        exporter("getMetadata", getMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function getOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("getOwnMetadata", getOwnMetadata);
        /**
         * Gets the metadata keys defined on the target object or its prototype chain.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "method");
         *
         */
        function getMetadataKeys(target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryMetadataKeys(target, propertyKey);
        }
        exporter("getMetadataKeys", getMetadataKeys);
        /**
         * Gets the unique metadata keys defined on the target object.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "method");
         *
         */
        function getOwnMetadataKeys(target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryOwnMetadataKeys(target, propertyKey);
        }
        exporter("getOwnMetadataKeys", getOwnMetadataKeys);
        /**
         * Deletes the metadata entry from the target object with the provided key.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata entry was found and deleted; otherwise, false.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.deleteMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function deleteMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            var metadataMap = GetOrCreateMetadataMap(target, propertyKey, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return false;
            if (!metadataMap.delete(metadataKey))
                return false;
            if (metadataMap.size > 0)
                return true;
            var targetMetadata = Metadata.get(target);
            targetMetadata.delete(propertyKey);
            if (targetMetadata.size > 0)
                return true;
            Metadata.delete(target);
            return true;
        }
        exporter("deleteMetadata", deleteMetadata);
        function DecorateConstructor(decorators, target) {
            for (var i = decorators.length - 1; i >= 0; --i) {
                var decorator = decorators[i];
                var decorated = decorator(target);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsConstructor(decorated))
                        throw new TypeError();
                    target = decorated;
                }
            }
            return target;
        }
        function DecorateProperty(decorators, target, propertyKey, descriptor) {
            for (var i = decorators.length - 1; i >= 0; --i) {
                var decorator = decorators[i];
                var decorated = decorator(target, propertyKey, descriptor);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsObject(decorated))
                        throw new TypeError();
                    descriptor = decorated;
                }
            }
            return descriptor;
        }
        function GetOrCreateMetadataMap(O, P, Create) {
            var targetMetadata = Metadata.get(O);
            if (IsUndefined(targetMetadata)) {
                if (!Create)
                    return undefined;
                targetMetadata = new _Map();
                Metadata.set(O, targetMetadata);
            }
            var metadataMap = targetMetadata.get(P);
            if (IsUndefined(metadataMap)) {
                if (!Create)
                    return undefined;
                metadataMap = new _Map();
                targetMetadata.set(P, metadataMap);
            }
            return metadataMap;
        }
        // 3.1.1.1 OrdinaryHasMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasmetadata
        function OrdinaryHasMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn)
                return true;
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent))
                return OrdinaryHasMetadata(MetadataKey, parent, P);
            return false;
        }
        // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata
        function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return false;
            return ToBoolean(metadataMap.has(MetadataKey));
        }
        // 3.1.3.1 OrdinaryGetMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetmetadata
        function OrdinaryGetMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn)
                return OrdinaryGetOwnMetadata(MetadataKey, O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent))
                return OrdinaryGetMetadata(MetadataKey, parent, P);
            return undefined;
        }
        // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata
        function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return undefined;
            return metadataMap.get(MetadataKey);
        }
        // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata
        function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ true);
            metadataMap.set(MetadataKey, MetadataValue);
        }
        // 3.1.6.1 OrdinaryMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarymetadatakeys
        function OrdinaryMetadataKeys(O, P) {
            var ownKeys = OrdinaryOwnMetadataKeys(O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (parent === null)
                return ownKeys;
            var parentKeys = OrdinaryMetadataKeys(parent, P);
            if (parentKeys.length <= 0)
                return ownKeys;
            if (ownKeys.length <= 0)
                return parentKeys;
            var set = new _Set();
            var keys = [];
            for (var _i = 0, ownKeys_1 = ownKeys; _i < ownKeys_1.length; _i++) {
                var key = ownKeys_1[_i];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            for (var _a = 0, parentKeys_1 = parentKeys; _a < parentKeys_1.length; _a++) {
                var key = parentKeys_1[_a];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            return keys;
        }
        // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys
        function OrdinaryOwnMetadataKeys(O, P) {
            var keys = [];
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return keys;
            var keysObj = metadataMap.keys();
            var iterator = GetIterator(keysObj);
            var k = 0;
            while (true) {
                var next = IteratorStep(iterator);
                if (!next) {
                    keys.length = k;
                    return keys;
                }
                var nextValue = IteratorValue(next);
                try {
                    keys[k] = nextValue;
                }
                catch (e) {
                    try {
                        IteratorClose(iterator);
                    }
                    finally {
                        throw e;
                    }
                }
                k++;
            }
        }
        // 6 ECMAScript Data Typ0es and Values
        // https://tc39.github.io/ecma262/#sec-ecmascript-data-types-and-values
        function Type(x) {
            if (x === null)
                return 1 /* Null */;
            switch (typeof x) {
                case "undefined": return 0 /* Undefined */;
                case "boolean": return 2 /* Boolean */;
                case "string": return 3 /* String */;
                case "symbol": return 4 /* Symbol */;
                case "number": return 5 /* Number */;
                case "object": return x === null ? 1 /* Null */ : 6 /* Object */;
                default: return 6 /* Object */;
            }
        }
        // 6.1.1 The Undefined Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-undefined-type
        function IsUndefined(x) {
            return x === undefined;
        }
        // 6.1.2 The Null Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-null-type
        function IsNull(x) {
            return x === null;
        }
        // 6.1.5 The Symbol Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-symbol-type
        function IsSymbol(x) {
            return typeof x === "symbol";
        }
        // 6.1.7 The Object Type
        // https://tc39.github.io/ecma262/#sec-object-type
        function IsObject(x) {
            return typeof x === "object" ? x !== null : typeof x === "function";
        }
        // 7.1 Type Conversion
        // https://tc39.github.io/ecma262/#sec-type-conversion
        // 7.1.1 ToPrimitive(input [, PreferredType])
        // https://tc39.github.io/ecma262/#sec-toprimitive
        function ToPrimitive(input, PreferredType) {
            switch (Type(input)) {
                case 0 /* Undefined */: return input;
                case 1 /* Null */: return input;
                case 2 /* Boolean */: return input;
                case 3 /* String */: return input;
                case 4 /* Symbol */: return input;
                case 5 /* Number */: return input;
            }
            var hint = "string" ;
            var exoticToPrim = GetMethod(input, toPrimitiveSymbol);
            if (exoticToPrim !== undefined) {
                var result = exoticToPrim.call(input, hint);
                if (IsObject(result))
                    throw new TypeError();
                return result;
            }
            return OrdinaryToPrimitive(input);
        }
        // 7.1.1.1 OrdinaryToPrimitive(O, hint)
        // https://tc39.github.io/ecma262/#sec-ordinarytoprimitive
        function OrdinaryToPrimitive(O, hint) {
            var valueOf, result; {
                var toString_1 = O.toString;
                if (IsCallable(toString_1)) {
                    var result = toString_1.call(O);
                    if (!IsObject(result))
                        return result;
                }
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result))
                        return result;
                }
            }
            throw new TypeError();
        }
        // 7.1.2 ToBoolean(argument)
        // https://tc39.github.io/ecma262/2016/#sec-toboolean
        function ToBoolean(argument) {
            return !!argument;
        }
        // 7.1.12 ToString(argument)
        // https://tc39.github.io/ecma262/#sec-tostring
        function ToString(argument) {
            return "" + argument;
        }
        // 7.1.14 ToPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-topropertykey
        function ToPropertyKey(argument) {
            var key = ToPrimitive(argument);
            if (IsSymbol(key))
                return key;
            return ToString(key);
        }
        // 7.2 Testing and Comparison Operations
        // https://tc39.github.io/ecma262/#sec-testing-and-comparison-operations
        // 7.2.2 IsArray(argument)
        // https://tc39.github.io/ecma262/#sec-isarray
        function IsArray(argument) {
            return Array.isArray
                ? Array.isArray(argument)
                : argument instanceof Object
                    ? argument instanceof Array
                    : Object.prototype.toString.call(argument) === "[object Array]";
        }
        // 7.2.3 IsCallable(argument)
        // https://tc39.github.io/ecma262/#sec-iscallable
        function IsCallable(argument) {
            // NOTE: This is an approximation as we cannot check for [[Call]] internal method.
            return typeof argument === "function";
        }
        // 7.2.4 IsConstructor(argument)
        // https://tc39.github.io/ecma262/#sec-isconstructor
        function IsConstructor(argument) {
            // NOTE: This is an approximation as we cannot check for [[Construct]] internal method.
            return typeof argument === "function";
        }
        // 7.2.7 IsPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-ispropertykey
        function IsPropertyKey(argument) {
            switch (Type(argument)) {
                case 3 /* String */: return true;
                case 4 /* Symbol */: return true;
                default: return false;
            }
        }
        // 7.3 Operations on Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-objects
        // 7.3.9 GetMethod(V, P)
        // https://tc39.github.io/ecma262/#sec-getmethod
        function GetMethod(V, P) {
            var func = V[P];
            if (func === undefined || func === null)
                return undefined;
            if (!IsCallable(func))
                throw new TypeError();
            return func;
        }
        // 7.4 Operations on Iterator Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-iterator-objects
        function GetIterator(obj) {
            var method = GetMethod(obj, iteratorSymbol);
            if (!IsCallable(method))
                throw new TypeError(); // from Call
            var iterator = method.call(obj);
            if (!IsObject(iterator))
                throw new TypeError();
            return iterator;
        }
        // 7.4.4 IteratorValue(iterResult)
        // https://tc39.github.io/ecma262/2016/#sec-iteratorvalue
        function IteratorValue(iterResult) {
            return iterResult.value;
        }
        // 7.4.5 IteratorStep(iterator)
        // https://tc39.github.io/ecma262/#sec-iteratorstep
        function IteratorStep(iterator) {
            var result = iterator.next();
            return result.done ? false : result;
        }
        // 7.4.6 IteratorClose(iterator, completion)
        // https://tc39.github.io/ecma262/#sec-iteratorclose
        function IteratorClose(iterator) {
            var f = iterator["return"];
            if (f)
                f.call(iterator);
        }
        // 9.1 Ordinary Object Internal Methods and Internal Slots
        // https://tc39.github.io/ecma262/#sec-ordinary-object-internal-methods-and-internal-slots
        // 9.1.1.1 OrdinaryGetPrototypeOf(O)
        // https://tc39.github.io/ecma262/#sec-ordinarygetprototypeof
        function OrdinaryGetPrototypeOf(O) {
            var proto = Object.getPrototypeOf(O);
            if (typeof O !== "function" || O === functionPrototype)
                return proto;
            // TypeScript doesn't set __proto__ in ES5, as it's non-standard.
            // Try to determine the superclass constructor. Compatible implementations
            // must either set __proto__ on a subclass constructor to the superclass constructor,
            // or ensure each class has a valid `constructor` property on its prototype that
            // points back to the constructor.
            // If this is not the same as Function.[[Prototype]], then this is definately inherited.
            // This is the case when in ES6 or when using __proto__ in a compatible browser.
            if (proto !== functionPrototype)
                return proto;
            // If the super prototype is Object.prototype, null, or undefined, then we cannot determine the heritage.
            var prototype = O.prototype;
            var prototypeProto = prototype && Object.getPrototypeOf(prototype);
            if (prototypeProto == null || prototypeProto === Object.prototype)
                return proto;
            // If the constructor was not a function, then we cannot determine the heritage.
            var constructor = prototypeProto.constructor;
            if (typeof constructor !== "function")
                return proto;
            // If we have some kind of self-reference, then we cannot determine the heritage.
            if (constructor === O)
                return proto;
            // we have a pretty good guess at the heritage.
            return constructor;
        }
        // naive Map shim
        function CreateMapPolyfill() {
            var cacheSentinel = {};
            var arraySentinel = [];
            var MapIterator = /** @class */ (function () {
                function MapIterator(keys, values, selector) {
                    this._index = 0;
                    this._keys = keys;
                    this._values = values;
                    this._selector = selector;
                }
                MapIterator.prototype["@@iterator"] = function () { return this; };
                MapIterator.prototype[iteratorSymbol] = function () { return this; };
                MapIterator.prototype.next = function () {
                    var index = this._index;
                    if (index >= 0 && index < this._keys.length) {
                        var result = this._selector(this._keys[index], this._values[index]);
                        if (index + 1 >= this._keys.length) {
                            this._index = -1;
                            this._keys = arraySentinel;
                            this._values = arraySentinel;
                        }
                        else {
                            this._index++;
                        }
                        return { value: result, done: false };
                    }
                    return { value: undefined, done: true };
                };
                MapIterator.prototype.throw = function (error) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    throw error;
                };
                MapIterator.prototype.return = function (value) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    return { value: value, done: true };
                };
                return MapIterator;
            }());
            return /** @class */ (function () {
                function Map() {
                    this._keys = [];
                    this._values = [];
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                }
                Object.defineProperty(Map.prototype, "size", {
                    get: function () { return this._keys.length; },
                    enumerable: true,
                    configurable: true
                });
                Map.prototype.has = function (key) { return this._find(key, /*insert*/ false) >= 0; };
                Map.prototype.get = function (key) {
                    var index = this._find(key, /*insert*/ false);
                    return index >= 0 ? this._values[index] : undefined;
                };
                Map.prototype.set = function (key, value) {
                    var index = this._find(key, /*insert*/ true);
                    this._values[index] = value;
                    return this;
                };
                Map.prototype.delete = function (key) {
                    var index = this._find(key, /*insert*/ false);
                    if (index >= 0) {
                        var size = this._keys.length;
                        for (var i = index + 1; i < size; i++) {
                            this._keys[i - 1] = this._keys[i];
                            this._values[i - 1] = this._values[i];
                        }
                        this._keys.length--;
                        this._values.length--;
                        if (key === this._cacheKey) {
                            this._cacheKey = cacheSentinel;
                            this._cacheIndex = -2;
                        }
                        return true;
                    }
                    return false;
                };
                Map.prototype.clear = function () {
                    this._keys.length = 0;
                    this._values.length = 0;
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                };
                Map.prototype.keys = function () { return new MapIterator(this._keys, this._values, getKey); };
                Map.prototype.values = function () { return new MapIterator(this._keys, this._values, getValue); };
                Map.prototype.entries = function () { return new MapIterator(this._keys, this._values, getEntry); };
                Map.prototype["@@iterator"] = function () { return this.entries(); };
                Map.prototype[iteratorSymbol] = function () { return this.entries(); };
                Map.prototype._find = function (key, insert) {
                    if (this._cacheKey !== key) {
                        this._cacheIndex = this._keys.indexOf(this._cacheKey = key);
                    }
                    if (this._cacheIndex < 0 && insert) {
                        this._cacheIndex = this._keys.length;
                        this._keys.push(key);
                        this._values.push(undefined);
                    }
                    return this._cacheIndex;
                };
                return Map;
            }());
            function getKey(key, _) {
                return key;
            }
            function getValue(_, value) {
                return value;
            }
            function getEntry(key, value) {
                return [key, value];
            }
        }
        // naive Set shim
        function CreateSetPolyfill() {
            return /** @class */ (function () {
                function Set() {
                    this._map = new _Map();
                }
                Object.defineProperty(Set.prototype, "size", {
                    get: function () { return this._map.size; },
                    enumerable: true,
                    configurable: true
                });
                Set.prototype.has = function (value) { return this._map.has(value); };
                Set.prototype.add = function (value) { return this._map.set(value, value), this; };
                Set.prototype.delete = function (value) { return this._map.delete(value); };
                Set.prototype.clear = function () { this._map.clear(); };
                Set.prototype.keys = function () { return this._map.keys(); };
                Set.prototype.values = function () { return this._map.values(); };
                Set.prototype.entries = function () { return this._map.entries(); };
                Set.prototype["@@iterator"] = function () { return this.keys(); };
                Set.prototype[iteratorSymbol] = function () { return this.keys(); };
                return Set;
            }());
        }
        // naive WeakMap shim
        function CreateWeakMapPolyfill() {
            var UUID_SIZE = 16;
            var keys = HashMap.create();
            var rootKey = CreateUniqueKey();
            return /** @class */ (function () {
                function WeakMap() {
                    this._key = CreateUniqueKey();
                }
                WeakMap.prototype.has = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.has(table, this._key) : false;
                };
                WeakMap.prototype.get = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.get(table, this._key) : undefined;
                };
                WeakMap.prototype.set = function (target, value) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ true);
                    table[this._key] = value;
                    return this;
                };
                WeakMap.prototype.delete = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? delete table[this._key] : false;
                };
                WeakMap.prototype.clear = function () {
                    // NOTE: not a real clear, just makes the previous data unreachable
                    this._key = CreateUniqueKey();
                };
                return WeakMap;
            }());
            function CreateUniqueKey() {
                var key;
                do
                    key = "@@WeakMap@@" + CreateUUID();
                while (HashMap.has(keys, key));
                keys[key] = true;
                return key;
            }
            function GetOrCreateWeakMapTable(target, create) {
                if (!hasOwn.call(target, rootKey)) {
                    if (!create)
                        return undefined;
                    Object.defineProperty(target, rootKey, { value: HashMap.create() });
                }
                return target[rootKey];
            }
            function FillRandomBytes(buffer, size) {
                for (var i = 0; i < size; ++i)
                    buffer[i] = Math.random() * 0xff | 0;
                return buffer;
            }
            function GenRandomBytes(size) {
                if (typeof Uint8Array === "function") {
                    if (typeof crypto !== "undefined")
                        return crypto.getRandomValues(new Uint8Array(size));
                    if (typeof msCrypto !== "undefined")
                        return msCrypto.getRandomValues(new Uint8Array(size));
                    return FillRandomBytes(new Uint8Array(size), size);
                }
                return FillRandomBytes(new Array(size), size);
            }
            function CreateUUID() {
                var data = GenRandomBytes(UUID_SIZE);
                // mark as random - RFC 4122 § 4.4
                data[6] = data[6] & 0x4f | 0x40;
                data[8] = data[8] & 0xbf | 0x80;
                var result = "";
                for (var offset = 0; offset < UUID_SIZE; ++offset) {
                    var byte = data[offset];
                    if (offset === 4 || offset === 6 || offset === 8)
                        result += "-";
                    if (byte < 16)
                        result += "0";
                    result += byte.toString(16).toLowerCase();
                }
                return result;
            }
        }
        // uses a heuristic used by v8 and chakra to force an object into dictionary mode.
        function MakeDictionary(obj) {
            obj.__ = undefined;
            delete obj.__;
            return obj;
        }
    });
})(Reflect$1 || (Reflect$1 = {}));

const initOnceMetaDataKey=Symbol("initOnce");

class OhmModule{get size(){let t=0;for(let e in this.directiveHosts)t++;return t}bootstrapModule(){if(this.moduleOptions.beforeModuleBootstrap.length&&this.runBeforeBootstrap(),this.moduleOptions&&this.moduleOptions.directives.length)for(let t=0;t<this.moduleOptions.directives.length;t++)this.initDirectiveInstances(this.moduleOptions.directives[t]);return this.moduleOptions.afterModuleBootstrap.length&&this.runAfterBootstrap(),this}destroyModule(e){let o=Ohm.getModule(this.name,!0);this.emptyModule(e),Ohm.modules.splice(o,1);}emptyModule(e){for(let o in this.directiveHosts){let i=this.directiveHosts[o];(!e||e.contains(i.host))&&(this.directiveHosts[o].applyToDirectives((t,e)=>{"__onAppDestroy"in t&&t.__onAppDestroy(),"onAppDestroy"in t&&t.onAppDestroy(),this.directiveHosts[o].directives.splice(e,1);}),"ohmHostID"in i.host&&delete this.directiveHosts[o].host.ohmHostID,i.host.removeAttribute(Ohm.ID_ATTR_NAME));}}getInstanceByHostId(t,e){let o=this.directiveHosts[t];return o?o.getDirectiveByConstructor(e):null}getInstancesByConstructor(t){let e=[];for(let o in this.directiveHosts){let i=this.getInstanceByHostId(o,t);i&&e.push(i);}return e}getInstanceByHostElement(t,e){return t&&"ohmHostID"in t?this.getInstanceByHostId(t.ohmHostID,e):null}getHostChildrenDirectives(t,e){let o=[],i=t.querySelectorAll(e.selector);for(let t=0;t<i.length;t++){let s=this.getInstanceByHostElement(i[t],e);s&&o.push(s);}return o}update(){let{moduleHost:t}=this.moduleOptions,e=this.moduleOptions.directives.map(t=>t.selector).join(", ");if(!t||!document.contains(t)){this.destroyModule();return}let o=t.querySelectorAll(e);for(let t in this.directiveHosts){let e=this.directiveHosts[t];document.body.contains(e.host)||(this.destroyHostExpiredDirectives(e.host),this.destroyExpiredHosts());}for(let t=0;t<o.length;t++)this.updateHostDirectives(o[t]);}initDirectiveInstances(t){let e=this.moduleOptions.moduleHost.querySelectorAll(OhmModule.optimiseSelector(t.selector));for(let o=0;o<e.length;o++)this.initDirective(t,e[o]);}initDirective(s,r){let n;let l=!0===Reflect.getMetadata(initOnceMetaDataKey,s);if(Ohm.getDirectiveFromHostElement(r,s))return;if(l){let e=Ohm.getDirectiveInstances(s).length;if(e>=1){1===e&&console.error(`${s.name} should be implemented only once since decorator @InitOnce has been applied to it.`);return}}let p=r.getAttribute(Ohm.ID_ATTR_NAME);if(p){if((n=p)in this.directiveHosts&&this.directiveHosts[n].hasDirectiveFrom(s))return}else n=generateRdmString$1({length:24,chars:"ABCDEFHIJKLMNOPQRSTUVWXYZabcdefhijklmnopqrstuvwxyz0123456789_"}),r.setAttribute(Ohm.ID_ATTR_NAME,n),Object.defineProperty(r,"ohmHostID",{value:n,configurable:!0});let h=new s(r),c=generateRdmString$1({length:24,chars:"ABCDEFHIJKLMNOPQRSTUVWXYZabcdefhijklmnopqrstuvwxyz0123456789_"});h.__onAppInit(),Object.defineProperty(h,"ohmID",{value:c,configurable:!0}),n in this.directiveHosts?this.directiveHosts[n].directives.push(h):this.directiveHosts[n]=new DirectiveHost(r,[h]);}getDirectiveHost(t){return t&&"ohmHostID"in t?this.directiveHosts[t.ohmHostID]:null}updateHostDirectives(e){let o=e.getAttribute(Ohm.ID_ATTR_NAME)||e.ohmID;if(o)this.updateHostMissingDirectives(e),this.destroyHostExpiredDirectives(e),this.destroyExpiredHosts();else for(let t=0;t<this.moduleOptions.directives.length;t++){let o=this.moduleOptions.directives[t],i=OhmModule.optimiseSelector(o.selector);e.matches(i)&&this.initDirective(o,e);}this.directiveHosts[o]?.emitChange();}updateHostMissingDirectives(e){let o=e.getAttribute(Ohm.ID_ATTR_NAME)||e.ohmID,i=this.directiveHosts[o];if(i){let t=i.directives.map(t=>t.constructor);for(let o=0;o<this.moduleOptions.directives.length;o++){let i=this.moduleOptions.directives[o],s=OhmModule.optimiseSelector(i.selector);e.matches(s)&&-1===t.indexOf(i)&&this.initDirective(i,e);}}}destroyHostExpiredDirectives(e){let o=e.getAttribute(Ohm.ID_ATTR_NAME)||e.ohmID,i=this.directiveHosts[o];if(i){let t=i.directives;for(let i=0;i<t.length;i++){let s=t[i],r=OhmModule.optimiseSelector(s.constructor.selector);e.matches(r)||(s.__onAppDestroy(),"onAppDestroy"in s&&s.onAppDestroy(),this.directiveHosts[o].directives.splice(i,1));}}}destroyExpiredHosts(){for(let t in this.directiveHosts){let e=this.directiveHosts[t];this.moduleOptions.moduleHost.contains(e.host)||e.directives.forEach((e,o)=>{e.__onAppDestroy(),"onAppDestroy"in e&&e.onAppDestroy(),this.directiveHosts[t].directives.splice(o,1);});}}triggerChange(t){t.__onAppChange(),t.hasOwnProperty("onAppChange")&&t.onAppChange();}static optimiseSelector(t){let e=t.replace(/\[(.*?)\]/g,"[data-$1]");return `${t}, ${e}`}runBeforeBootstrap(){let{beforeModuleBootstrap:t}=this.moduleOptions;for(let e=0;e<t.length;e++){let o=t[e];"function"==typeof o&&o();}this.moduleOptions.beforeModuleBootstrap=[];}runAfterBootstrap(){let{afterModuleBootstrap:t}=this.moduleOptions;for(let e=0;e<t.length;e++){let o=t[e];"function"==typeof o&&o();}this.moduleOptions.afterModuleBootstrap=[];}constructor(e,o){this.name=e,this.directiveHosts={},this.moduleOptions={moduleHost:document,directives:[],beforeModuleBootstrap:[],afterModuleBootstrap:[],beforeAppBootstrap:[],afterAppBootstrap:[]},this.moduleOptions={...this.moduleOptions,...o},this.moduleOptions.beforeAppBootstrap.length&&(Ohm.beforeAppBootstrap=[...Ohm.beforeAppBootstrap,...this.moduleOptions.beforeAppBootstrap]),this.moduleOptions.afterAppBootstrap.length&&(Ohm.afterAppBootstrap=[...Ohm.afterAppBootstrap,...this.moduleOptions.afterAppBootstrap]),Ohm.modules.push(this);}}

class Ohm{get hasBootstrapped(){return Ohm._hasBootstrappedValue}static module(e,r){let o=new OhmModule(e,r);return Ohm.registerDirectiveClasses(r.directives),o}static getModule(e,t=!1){for(let r=0;r<Ohm.modules.length;r++){let o=Ohm.modules[r];if(o.name===e)return t?r:o}return t?-1:null}static getDirectiveInstances(e){let t=[];for(let r=0;r<Ohm.modules.length;r++){let o=Ohm.modules[r].getInstancesByConstructor(e);o.length&&(t=[...t,...o]);}return t}static getDirectiveFromHostElement(e,t){for(let r=0;r<Ohm.modules.length;r++){let o=Ohm.modules[r].getInstanceByHostElement(e,t);if(null!==o)return o}return null}static waitForDirectiveFromHostElement(e,t,r=10,o=50){let s=(r,l,m)=>{for(let r=0;r<Ohm.modules.length;r++){let o=Ohm.modules[r].getInstanceByHostElement(e,t);if(null!==o){l(o);return}}if(r<=0){m(null);return}window.setTimeout(()=>{s(r-1,l);},o);};return new Promise(e=>{s(r,e);})}static getHostChildrenDirectives(e,t){let r=[];for(let o=0;o<Ohm.modules.length;o++){let s=Ohm.modules[o].getHostChildrenDirectives(e,t);s.length&&(r=[].concat(r,s));}return r}static getDirectivesFromHost(e){let t=[];for(let r=0;r<Ohm.modules.length;r++)Object.keys(Ohm.modules[r].directiveHosts).forEach(o=>{let s=Ohm.modules[r].directiveHosts[o];e.contains(s.host)&&t.push(...s.directives);});return t}static bootstrap({showLoadTime:e=!1}={}){if(Ohm._hasBootstrappedValue)throw Error("Multiple bootstrap call. Ohm cannot be bootstrapped more than once.");e&&"time"in window.console&&console.time("Ohm App bootstrap time"),Ohm.runFunctions("beforeAppBootstrap");for(let e=0;e<Ohm.modules.length;e++)try{Ohm.modules[e].bootstrapModule();}catch(e){console.error(e);}return Ohm.appBeforeInitDeferrer.resolve(),Ohm.appInitDeferrer.resolve(Ohm),Ohm._hasBootstrappedValue=!0,Ohm.runFunctions("afterAppBootstrap"),e&&"time"in window.console&&console.timeEnd("Ohm App bootstrap time"),Ohm}static update(){for(let e=Ohm.modules.length-1;e>=0;e--)Ohm.modules[e].update();}static destroy(){Ohm.runFunctions("beforeAppDestroy");for(let e=Ohm.modules.length-1;e>=0;e--)Ohm.modules[e].destroyModule();Ohm.appBeforeInitDeferrer=new Deferrer,Ohm.appInitDeferrer=new Deferrer,Ohm._hasBootstrappedValue=!1,Ohm.runFunctions("afterAppDestroy");}static empty(t){Ohm.runFunctions("beforeAppDestroy");for(let e=Ohm.modules.length-1;e>=0;e--)Ohm.modules[e].emptyModule(t);Ohm.appBeforeInitDeferrer=new Deferrer,Ohm.appInitDeferrer=new Deferrer,Ohm._hasBootstrappedValue=!1,Ohm.runFunctions("afterAppDestroy");}static registerDirectiveClasses(e){for(let t=0;t<e.length;t++){let r=e[t];-1===Ohm.registeredDirectiveClasses.indexOf(r)&&Ohm.registeredDirectiveClasses.push(r);}}static runFunctions(e){let t=Ohm[e];for(let e=0;e<t.length;e++){let r=t[e];"function"==typeof r&&r();}Ohm[e]=[];}static on(e,t){"function"==typeof t&&(Ohm.callbacks[e]||(Ohm.callbacks[e]=[]),Ohm.callbacks[e].push(t));}static off(e,t){Ohm.callbacks[e]&&(Ohm.callbacks[e]=Ohm.callbacks[e].filter(e=>e!==t));}static emit(e,...t){Ohm.callbacks[e]&&Ohm.callbacks[e].forEach(e=>{e(...t);});}}Ohm.modules=[],Ohm.appBeforeInitDeferrer=new Deferrer,Ohm.appInitDeferrer=new Deferrer,Ohm.onAppInit=Ohm.appInitDeferrer.promise,Ohm.onBeforeAppInit=Ohm.appBeforeInitDeferrer.promise,Ohm.ID_ATTR_NAME="_ohm-id",Ohm.registeredDirectiveClasses=[],Ohm._hasBootstrappedValue=!1,Ohm.beforeAppBootstrap=[],Ohm.afterAppBootstrap=[],Ohm.beforeAppDestroy=[],Ohm.afterAppDestroy=[],Ohm.callbacks={};

/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t$4=globalThis,e$5=t$4.ShadowRoot&&(void 0===t$4.ShadyCSS||t$4.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,s$2=Symbol(),o$2=new WeakMap;let n$2 = class n{constructor(t,e,o){if(this._$cssResult$=!0,o!==s$2)throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=t,this.t=e;}get styleSheet(){let t=this.o;const s=this.t;if(e$5&&void 0===t){const e=void 0!==s&&1===s.length;e&&(t=o$2.get(s)),void 0===t&&((this.o=t=new CSSStyleSheet).replaceSync(this.cssText),e&&o$2.set(s,t));}return t}toString(){return this.cssText}};const r$3=t=>new n$2("string"==typeof t?t:t+"",void 0,s$2),S$1=(s,o)=>{if(e$5)s.adoptedStyleSheets=o.map((t=>t instanceof CSSStyleSheet?t:t.styleSheet));else for(const e of o){const o=document.createElement("style"),n=t$4.litNonce;void 0!==n&&o.setAttribute("nonce",n),o.textContent=e.cssText,s.appendChild(o);}},c$2=e$5?t=>t:t=>t instanceof CSSStyleSheet?(t=>{let e="";for(const s of t.cssRules)e+=s.cssText;return r$3(e)})(t):t;

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const{is:i$1,defineProperty:e$4,getOwnPropertyDescriptor:r$2,getOwnPropertyNames:h$1,getOwnPropertySymbols:o$1,getPrototypeOf:n$1}=Object,a$1=globalThis,c$1=a$1.trustedTypes,l$1=c$1?c$1.emptyScript:"",p$1=a$1.reactiveElementPolyfillSupport,d$1=(t,s)=>t,u$1={toAttribute(t,s){switch(s){case Boolean:t=t?l$1:null;break;case Object:case Array:t=null==t?t:JSON.stringify(t);}return t},fromAttribute(t,s){let i=t;switch(s){case Boolean:i=null!==t;break;case Number:i=null===t?null:Number(t);break;case Object:case Array:try{i=JSON.parse(t);}catch(t){i=null;}}return i}},f$1=(t,s)=>!i$1(t,s),y$1={attribute:!0,type:String,converter:u$1,reflect:!1,hasChanged:f$1};Symbol.metadata??=Symbol("metadata"),a$1.litPropertyMetadata??=new WeakMap;class b extends HTMLElement{static addInitializer(t){this._$Ei(),(this.l??=[]).push(t);}static get observedAttributes(){return this.finalize(),this._$Eh&&[...this._$Eh.keys()]}static createProperty(t,s=y$1){if(s.state&&(s.attribute=!1),this._$Ei(),this.elementProperties.set(t,s),!s.noAccessor){const i=Symbol(),r=this.getPropertyDescriptor(t,i,s);void 0!==r&&e$4(this.prototype,t,r);}}static getPropertyDescriptor(t,s,i){const{get:e,set:h}=r$2(this.prototype,t)??{get(){return this[s]},set(t){this[s]=t;}};return {get(){return e?.call(this)},set(s){const r=e?.call(this);h.call(this,s),this.requestUpdate(t,r,i);},configurable:!0,enumerable:!0}}static getPropertyOptions(t){return this.elementProperties.get(t)??y$1}static _$Ei(){if(this.hasOwnProperty(d$1("elementProperties")))return;const t=n$1(this);t.finalize(),void 0!==t.l&&(this.l=[...t.l]),this.elementProperties=new Map(t.elementProperties);}static finalize(){if(this.hasOwnProperty(d$1("finalized")))return;if(this.finalized=!0,this._$Ei(),this.hasOwnProperty(d$1("properties"))){const t=this.properties,s=[...h$1(t),...o$1(t)];for(const i of s)this.createProperty(i,t[i]);}const t=this[Symbol.metadata];if(null!==t){const s=litPropertyMetadata.get(t);if(void 0!==s)for(const[t,i]of s)this.elementProperties.set(t,i);}this._$Eh=new Map;for(const[t,s]of this.elementProperties){const i=this._$Eu(t,s);void 0!==i&&this._$Eh.set(i,t);}this.elementStyles=this.finalizeStyles(this.styles);}static finalizeStyles(s){const i=[];if(Array.isArray(s)){const e=new Set(s.flat(1/0).reverse());for(const s of e)i.unshift(c$2(s));}else void 0!==s&&i.push(c$2(s));return i}static _$Eu(t,s){const i=s.attribute;return !1===i?void 0:"string"==typeof i?i:"string"==typeof t?t.toLowerCase():void 0}constructor(){super(),this._$Ep=void 0,this.isUpdatePending=!1,this.hasUpdated=!1,this._$Em=null,this._$Ev();}_$Ev(){this._$ES=new Promise((t=>this.enableUpdating=t)),this._$AL=new Map,this._$E_(),this.requestUpdate(),this.constructor.l?.forEach((t=>t(this)));}addController(t){(this._$EO??=new Set).add(t),void 0!==this.renderRoot&&this.isConnected&&t.hostConnected?.();}removeController(t){this._$EO?.delete(t);}_$E_(){const t=new Map,s=this.constructor.elementProperties;for(const i of s.keys())this.hasOwnProperty(i)&&(t.set(i,this[i]),delete this[i]);t.size>0&&(this._$Ep=t);}createRenderRoot(){const t=this.shadowRoot??this.attachShadow(this.constructor.shadowRootOptions);return S$1(t,this.constructor.elementStyles),t}connectedCallback(){this.renderRoot??=this.createRenderRoot(),this.enableUpdating(!0),this._$EO?.forEach((t=>t.hostConnected?.()));}enableUpdating(t){}disconnectedCallback(){this._$EO?.forEach((t=>t.hostDisconnected?.()));}attributeChangedCallback(t,s,i){this._$AK(t,i);}_$EC(t,s){const i=this.constructor.elementProperties.get(t),e=this.constructor._$Eu(t,i);if(void 0!==e&&!0===i.reflect){const r=(void 0!==i.converter?.toAttribute?i.converter:u$1).toAttribute(s,i.type);this._$Em=t,null==r?this.removeAttribute(e):this.setAttribute(e,r),this._$Em=null;}}_$AK(t,s){const i=this.constructor,e=i._$Eh.get(t);if(void 0!==e&&this._$Em!==e){const t=i.getPropertyOptions(e),r="function"==typeof t.converter?{fromAttribute:t.converter}:void 0!==t.converter?.fromAttribute?t.converter:u$1;this._$Em=e,this[e]=r.fromAttribute(s,t.type),this._$Em=null;}}requestUpdate(t,s,i){if(void 0!==t){if(i??=this.constructor.getPropertyOptions(t),!(i.hasChanged??f$1)(this[t],s))return;this.P(t,s,i);}!1===this.isUpdatePending&&(this._$ES=this._$ET());}P(t,s,i){this._$AL.has(t)||this._$AL.set(t,s),!0===i.reflect&&this._$Em!==t&&(this._$Ej??=new Set).add(t);}async _$ET(){this.isUpdatePending=!0;try{await this._$ES;}catch(t){Promise.reject(t);}const t=this.scheduleUpdate();return null!=t&&await t,!this.isUpdatePending}scheduleUpdate(){return this.performUpdate()}performUpdate(){if(!this.isUpdatePending)return;if(!this.hasUpdated){if(this.renderRoot??=this.createRenderRoot(),this._$Ep){for(const[t,s]of this._$Ep)this[t]=s;this._$Ep=void 0;}const t=this.constructor.elementProperties;if(t.size>0)for(const[s,i]of t)!0!==i.wrapped||this._$AL.has(s)||void 0===this[s]||this.P(s,this[s],i);}let t=!1;const s=this._$AL;try{t=this.shouldUpdate(s),t?(this.willUpdate(s),this._$EO?.forEach((t=>t.hostUpdate?.())),this.update(s)):this._$EU();}catch(s){throw t=!1,this._$EU(),s}t&&this._$AE(s);}willUpdate(t){}_$AE(t){this._$EO?.forEach((t=>t.hostUpdated?.())),this.hasUpdated||(this.hasUpdated=!0,this.firstUpdated(t)),this.updated(t);}_$EU(){this._$AL=new Map,this.isUpdatePending=!1;}get updateComplete(){return this.getUpdateComplete()}getUpdateComplete(){return this._$ES}shouldUpdate(t){return !0}update(t){this._$Ej&&=this._$Ej.forEach((t=>this._$EC(t,this[t]))),this._$EU();}updated(t){}firstUpdated(t){}}b.elementStyles=[],b.shadowRootOptions={mode:"open"},b[d$1("elementProperties")]=new Map,b[d$1("finalized")]=new Map,p$1?.({ReactiveElement:b}),(a$1.reactiveElementVersions??=[]).push("2.0.4");

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t$3=globalThis,i=t$3.trustedTypes,s$1=i?i.createPolicy("lit-html",{createHTML:t=>t}):void 0,e$3="$lit$",h=`lit$${Math.random().toFixed(9).slice(2)}$`,o="?"+h,n=`<${o}>`,r$1=document,l=()=>r$1.createComment(""),c=t=>null===t||"object"!=typeof t&&"function"!=typeof t,a=Array.isArray,u=t=>a(t)||"function"==typeof t?.[Symbol.iterator],d="[ \t\n\f\r]",f=/<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,v=/-->/g,_$1=/>/g,m=RegExp(`>|${d}(?:([^\\s"'>=/]+)(${d}*=${d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`,"g"),p=/'/g,g=/"/g,$=/^(?:script|style|textarea|title)$/i,y=t=>(i,...s)=>({_$litType$:t,strings:i,values:s}),x=y(1),w=Symbol.for("lit-noChange"),T=Symbol.for("lit-nothing"),A=new WeakMap,E=r$1.createTreeWalker(r$1,129);function C(t,i){if(!Array.isArray(t)||!t.hasOwnProperty("raw"))throw Error("invalid template strings array");return void 0!==s$1?s$1.createHTML(i):i}const P=(t,i)=>{const s=t.length-1,o=[];let r,l=2===i?"<svg>":"",c=f;for(let i=0;i<s;i++){const s=t[i];let a,u,d=-1,y=0;for(;y<s.length&&(c.lastIndex=y,u=c.exec(s),null!==u);)y=c.lastIndex,c===f?"!--"===u[1]?c=v:void 0!==u[1]?c=_$1:void 0!==u[2]?($.test(u[2])&&(r=RegExp("</"+u[2],"g")),c=m):void 0!==u[3]&&(c=m):c===m?">"===u[0]?(c=r??f,d=-1):void 0===u[1]?d=-2:(d=c.lastIndex-u[2].length,a=u[1],c=void 0===u[3]?m:'"'===u[3]?g:p):c===g||c===p?c=m:c===v||c===_$1?c=f:(c=m,r=void 0);const x=c===m&&t[i+1].startsWith("/>")?" ":"";l+=c===f?s+n:d>=0?(o.push(a),s.slice(0,d)+e$3+s.slice(d)+h+x):s+h+(-2===d?i:x);}return [C(t,l+(t[s]||"<?>")+(2===i?"</svg>":"")),o]};class V{constructor({strings:t,_$litType$:s},n){let r;this.parts=[];let c=0,a=0;const u=t.length-1,d=this.parts,[f,v]=P(t,s);if(this.el=V.createElement(f,n),E.currentNode=this.el.content,2===s){const t=this.el.content.firstChild;t.replaceWith(...t.childNodes);}for(;null!==(r=E.nextNode())&&d.length<u;){if(1===r.nodeType){if(r.hasAttributes())for(const t of r.getAttributeNames())if(t.endsWith(e$3)){const i=v[a++],s=r.getAttribute(t).split(h),e=/([.?@])?(.*)/.exec(i);d.push({type:1,index:c,name:e[2],strings:s,ctor:"."===e[1]?k:"?"===e[1]?H:"@"===e[1]?I:R}),r.removeAttribute(t);}else t.startsWith(h)&&(d.push({type:6,index:c}),r.removeAttribute(t));if($.test(r.tagName)){const t=r.textContent.split(h),s=t.length-1;if(s>0){r.textContent=i?i.emptyScript:"";for(let i=0;i<s;i++)r.append(t[i],l()),E.nextNode(),d.push({type:2,index:++c});r.append(t[s],l());}}}else if(8===r.nodeType)if(r.data===o)d.push({type:2,index:c});else {let t=-1;for(;-1!==(t=r.data.indexOf(h,t+1));)d.push({type:7,index:c}),t+=h.length-1;}c++;}}static createElement(t,i){const s=r$1.createElement("template");return s.innerHTML=t,s}}function N(t,i,s=t,e){if(i===w)return i;let h=void 0!==e?s._$Co?.[e]:s._$Cl;const o=c(i)?void 0:i._$litDirective$;return h?.constructor!==o&&(h?._$AO?.(!1),void 0===o?h=void 0:(h=new o(t),h._$AT(t,s,e)),void 0!==e?(s._$Co??=[])[e]=h:s._$Cl=h),void 0!==h&&(i=N(t,h._$AS(t,i.values),h,e)),i}class S{constructor(t,i){this._$AV=[],this._$AN=void 0,this._$AD=t,this._$AM=i;}get parentNode(){return this._$AM.parentNode}get _$AU(){return this._$AM._$AU}u(t){const{el:{content:i},parts:s}=this._$AD,e=(t?.creationScope??r$1).importNode(i,!0);E.currentNode=e;let h=E.nextNode(),o=0,n=0,l=s[0];for(;void 0!==l;){if(o===l.index){let i;2===l.type?i=new M(h,h.nextSibling,this,t):1===l.type?i=new l.ctor(h,l.name,l.strings,this,t):6===l.type&&(i=new L(h,this,t)),this._$AV.push(i),l=s[++n];}o!==l?.index&&(h=E.nextNode(),o++);}return E.currentNode=r$1,e}p(t){let i=0;for(const s of this._$AV)void 0!==s&&(void 0!==s.strings?(s._$AI(t,s,i),i+=s.strings.length-2):s._$AI(t[i])),i++;}}class M{get _$AU(){return this._$AM?._$AU??this._$Cv}constructor(t,i,s,e){this.type=2,this._$AH=T,this._$AN=void 0,this._$AA=t,this._$AB=i,this._$AM=s,this.options=e,this._$Cv=e?.isConnected??!0;}get parentNode(){let t=this._$AA.parentNode;const i=this._$AM;return void 0!==i&&11===t?.nodeType&&(t=i.parentNode),t}get startNode(){return this._$AA}get endNode(){return this._$AB}_$AI(t,i=this){t=N(this,t,i),c(t)?t===T||null==t||""===t?(this._$AH!==T&&this._$AR(),this._$AH=T):t!==this._$AH&&t!==w&&this._(t):void 0!==t._$litType$?this.$(t):void 0!==t.nodeType?this.T(t):u(t)?this.k(t):this._(t);}S(t){return this._$AA.parentNode.insertBefore(t,this._$AB)}T(t){this._$AH!==t&&(this._$AR(),this._$AH=this.S(t));}_(t){this._$AH!==T&&c(this._$AH)?this._$AA.nextSibling.data=t:this.T(r$1.createTextNode(t)),this._$AH=t;}$(t){const{values:i,_$litType$:s}=t,e="number"==typeof s?this._$AC(t):(void 0===s.el&&(s.el=V.createElement(C(s.h,s.h[0]),this.options)),s);if(this._$AH?._$AD===e)this._$AH.p(i);else {const t=new S(e,this),s=t.u(this.options);t.p(i),this.T(s),this._$AH=t;}}_$AC(t){let i=A.get(t.strings);return void 0===i&&A.set(t.strings,i=new V(t)),i}k(t){a(this._$AH)||(this._$AH=[],this._$AR());const i=this._$AH;let s,e=0;for(const h of t)e===i.length?i.push(s=new M(this.S(l()),this.S(l()),this,this.options)):s=i[e],s._$AI(h),e++;e<i.length&&(this._$AR(s&&s._$AB.nextSibling,e),i.length=e);}_$AR(t=this._$AA.nextSibling,i){for(this._$AP?.(!1,!0,i);t&&t!==this._$AB;){const i=t.nextSibling;t.remove(),t=i;}}setConnected(t){void 0===this._$AM&&(this._$Cv=t,this._$AP?.(t));}}class R{get tagName(){return this.element.tagName}get _$AU(){return this._$AM._$AU}constructor(t,i,s,e,h){this.type=1,this._$AH=T,this._$AN=void 0,this.element=t,this.name=i,this._$AM=e,this.options=h,s.length>2||""!==s[0]||""!==s[1]?(this._$AH=Array(s.length-1).fill(new String),this.strings=s):this._$AH=T;}_$AI(t,i=this,s,e){const h=this.strings;let o=!1;if(void 0===h)t=N(this,t,i,0),o=!c(t)||t!==this._$AH&&t!==w,o&&(this._$AH=t);else {const e=t;let n,r;for(t=h[0],n=0;n<h.length-1;n++)r=N(this,e[s+n],i,n),r===w&&(r=this._$AH[n]),o||=!c(r)||r!==this._$AH[n],r===T?t=T:t!==T&&(t+=(r??"")+h[n+1]),this._$AH[n]=r;}o&&!e&&this.j(t);}j(t){t===T?this.element.removeAttribute(this.name):this.element.setAttribute(this.name,t??"");}}class k extends R{constructor(){super(...arguments),this.type=3;}j(t){this.element[this.name]=t===T?void 0:t;}}class H extends R{constructor(){super(...arguments),this.type=4;}j(t){this.element.toggleAttribute(this.name,!!t&&t!==T);}}class I extends R{constructor(t,i,s,e,h){super(t,i,s,e,h),this.type=5;}_$AI(t,i=this){if((t=N(this,t,i,0)??T)===w)return;const s=this._$AH,e=t===T&&s!==T||t.capture!==s.capture||t.once!==s.once||t.passive!==s.passive,h=t!==T&&(s===T||e);e&&this.element.removeEventListener(this.name,this,s),h&&this.element.addEventListener(this.name,this,t),this._$AH=t;}handleEvent(t){"function"==typeof this._$AH?this._$AH.call(this.options?.host??this.element,t):this._$AH.handleEvent(t);}}class L{constructor(t,i,s){this.element=t,this.type=6,this._$AN=void 0,this._$AM=i,this.options=s;}get _$AU(){return this._$AM._$AU}_$AI(t){N(this,t);}}const z={P:e$3,A:h,C:o,M:1,L:P,R:S,D:u,V:N,I:M,H:R,N:H,U:I,B:k,F:L},Z=t$3.litHtmlPolyfillSupport;Z?.(V,M),(t$3.litHtmlVersions??=[]).push("3.1.4");const j=(t,i,s)=>{const e=s?.renderBefore??i;let h=e._$litPart$;if(void 0===h){const t=s?.renderBefore??null;e._$litPart$=h=new M(i.insertBefore(l(),t),t,void 0,s??{});}return h._$AI(t),h};

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */class s extends b{constructor(){super(...arguments),this.renderOptions={host:this},this._$Do=void 0;}createRenderRoot(){const t=super.createRenderRoot();return this.renderOptions.renderBefore??=t.firstChild,t}update(t){const i=this.render();this.hasUpdated||(this.renderOptions.isConnected=this.isConnected),super.update(t),this._$Do=j(i,this.renderRoot,this.renderOptions);}connectedCallback(){super.connectedCallback(),this._$Do?.setConnected(!0);}disconnectedCallback(){super.disconnectedCallback(),this._$Do?.setConnected(!1);}render(){return w}}s._$litElement$=!0,s[("finalized")]=!0,globalThis.litElementHydrateSupport?.({LitElement:s});const r=globalThis.litElementPolyfillSupport;r?.({LitElement:s});(globalThis.litElementVersions??=[]).push("4.0.6");

async function lazyModule(t,o,r={}){let i=[];for(let e in o)try{null!==document.querySelector(e)&&("function"==typeof o[e]?i.push(o[e]()):o[e].condition()&&i.push(o[e].factory()));}catch(e){console.error(e);}let c=await Promise.all(i);return r.directives||(r.directives=[]),r.directives=[...c,...r.directives],Ohm.module(t,r)}

const scriptRel = 'modulepreload';const assetsURL = function(dep, importerUrl) { return window.Pact.getViteAssetUrl(dep, importerUrl); }; const __oldAssetsURL = function(dep, importerUrl) { return dep[0] === '.' ? new URL(dep, importerUrl).href : dep };const seen = {};const __vitePreload = function preload(baseModule, deps, importerUrl) {
  let promise = Promise.resolve();
  if (true && deps && deps.length > 0) {
    const links = document.getElementsByTagName("link");
    const cspNonceMeta = document.querySelector(
      "meta[property=csp-nonce]"
    );
    const cspNonce = cspNonceMeta?.nonce || cspNonceMeta?.getAttribute("nonce");
    promise = Promise.all(
      deps.map((dep) => {
        dep = assetsURL(dep, importerUrl);
        if (dep in seen) return;
        seen[dep] = true;
        const isCss = dep.endsWith(".css");
        const cssSelector = isCss ? '[rel="stylesheet"]' : "";
        const isBaseRelative = !!importerUrl;
        if (isBaseRelative) {
          for (let i = links.length - 1; i >= 0; i--) {
            const link2 = links[i];
            if (link2.href === dep && (!isCss || link2.rel === "stylesheet")) {
              return;
            }
          }
        } else if (document.querySelector(`link[href="${dep}"]${cssSelector}`)) {
          return;
        }
        const link = document.createElement("link");
        link.rel = isCss ? "stylesheet" : scriptRel;
        if (!isCss) {
          link.as = "script";
          link.crossOrigin = "";
        }
        link.href = dep;
        if (cspNonce) {
          link.setAttribute("nonce", cspNonce);
        }
        document.head.appendChild(link);
        if (isCss) {
          return new Promise((res, rej) => {
            link.addEventListener("load", res);
            link.addEventListener(
              "error",
              () => rej(new Error(`Unable to preload CSS for ${dep}`))
            );
          });
        }
      })
    );
  }
  return promise.then(() => baseModule()).catch((err) => {
    const e = new Event("vite:preloadError", { cancelable: true });
    e.payload = err;
    window.dispatchEvent(e);
    if (!e.defaultPrevented) {
      throw err;
    }
  });
};

const lazyDirectives={"active-filters":()=>__vitePreload(() => import('./bundled-active-filters.component.js'),true?__vite__mapDeps([0]):void 0,import.meta.url).then(e=>e.ActiveFilters),"customer-orders":()=>__vitePreload(() => import('./bundled-customer-orders.component.js'),true?__vite__mapDeps([1]):void 0,import.meta.url).then(e=>e.CustomerOrdersComponent),lazyvideo:()=>__vitePreload(() => import('./bundled-lazyvideo.component.js'),true?[]:void 0,import.meta.url).then(e=>e.LazyVideo),notifications:()=>__vitePreload(() => import('./bundled-notifications.component.js'),true?__vite__mapDeps([2]):void 0,import.meta.url).then(e=>e.Notifications),"pdp-bundled-items":()=>__vitePreload(() => import('./bundled-pdp-bundled-items.component.js'),true?[]:void 0,import.meta.url).then(e=>e.PdpBundledItems),"quick-shop":()=>__vitePreload(() => import('./bundled-quick-shop.component.js'),true?[]:void 0,import.meta.url).then(e=>e.QuickShop),"edit-modal":()=>__vitePreload(() => import('./bundled-edit-modal.component.js'),true?[]:void 0,import.meta.url).then(e=>e.EditModal),"wallpaper-calculator":()=>__vitePreload(() => import('./bundled-wallpaper-calculator.component.js'),true?[]:void 0,import.meta.url).then(e=>e.WallpaperCalculator),body:()=>__vitePreload(() => import('./bundled-accessibility.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.Accessibility),"[accordion]":()=>__vitePreload(() => import('./bundled-accordion.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.Accordion),"[account-portal]":()=>__vitePreload(() => import('./bundled-account-portal.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.AccountPortal),"[add-to-cart]":()=>__vitePreload(() => import('./bundled-add-to-cart.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.AddToCart),"[birthday-field]":()=>__vitePreload(() => import('./bundled-birthday-field.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.BirthdayField),"[burger]":()=>__vitePreload(() => import('./bundled-burger.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.Burger),"[carousel]":()=>__vitePreload(() => import('./bundled-carousel.directive.js').then(n => n.c),true?[]:void 0,import.meta.url).then(e=>e.Carousel),"[cart-counter]":()=>__vitePreload(() => import('./bundled-cart-counter.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.CartCounter),"[cart-listener]":()=>__vitePreload(() => import('./bundled-cart-listener.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.CartListener),"[catalog-form]":()=>__vitePreload(() => import('./bundled-catalog-form.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.CatalogForm),"[collapsing-header]":()=>__vitePreload(() => import('./bundled-collapsing-header.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.CollapsingHeader),"[collection-grid]":()=>__vitePreload(() => import('./bundled-filters.directive.js').then(n => n.c),true?__vite__mapDeps([0]):void 0,import.meta.url).then(e=>e.CollectionGrid),"[color-selector]":()=>__vitePreload(() => import('./bundled-color-selector.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ColorSelector),"[copy-to-clipboard]":()=>__vitePreload(() => import('./bundled-copy-to-clipboard.directive.js'),true?__vite__mapDeps([3]):void 0,import.meta.url).then(e=>e.CopyToClipboard),"localization-form":()=>__vitePreload(() => import('./bundled-currency-selector.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.CurrencySelector),".descriptionTabs":()=>__vitePreload(() => import('./bundled-description-tabs.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.DescriptionTabs),".desktopOnly":()=>__vitePreload(() => import('./bundled-desktop-only.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.DesktopOnly),"[dynamic-checkout]":()=>__vitePreload(() => import('./bundled-dynamic-checkout.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.DynamicCheckout),"[dynamic-sections]":()=>__vitePreload(() => import('./bundled-dynamic-sections.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.DynamicSections),"[filters]":()=>__vitePreload(() => import('./bundled-filters.directive.js').then(n => n.f),true?__vite__mapDeps([0]):void 0,import.meta.url).then(e=>e.Filters),"[gift-card-form]":()=>__vitePreload(() => import('./bundled-gift-card-form.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.GiftCardForm),"[help-faqs]":()=>__vitePreload(() => import('./bundled-help-and-faqs.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.HelpAndFaqs),"[hide-element]":()=>__vitePreload(() => import('./bundled-hide-element.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.HideElement),"[input-requirements]":()=>__vitePreload(() => import('./bundled-input-requirements.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.InputRequirements),"[klaviyo-bis]":()=>__vitePreload(() => import('./bundled-klaviyo-bis.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.KlaviyoBis),"[line-reveal]":()=>__vitePreload(() => import('./bundled-line-reveal.directive.js'),true?__vite__mapDeps([4]):void 0,import.meta.url).then(e=>e.LineReveal),".loadingBar":()=>__vitePreload(() => import('./bundled-loading-bar.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.LoadingBar),"[login-form]":()=>__vitePreload(() => import('./bundled-login-form.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.LoginForm),"[megamenu-handler]":{factory:()=>__vitePreload(() => import('./bundled-megamenu-handler.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.MegamenuHandler),condition:()=>window.Shopify.designMode},"[mobile-nav]":()=>__vitePreload(() => import('./bundled-mobile-nav.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.MobileNav),".mobileOnly":()=>__vitePreload(() => import('./bundled-mobile-only.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.MobileOnly),"[nav-drawer]":()=>__vitePreload(() => import('./bundled-nav-drawer.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.NavDrawer),"[nav-tracking]":()=>__vitePreload(() => import('./bundled-nav-tracking.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.NavTracking),"[newsletter-form]":()=>__vitePreload(() => import('./bundled-newsletter-form.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.NewsletterForm),"[option-watcher]":()=>__vitePreload(() => import('./bundled-option-watcher.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.OptionWatcher),"[pass-attribute-to-section]":()=>__vitePreload(() => import('./bundled-pass-attribute-to-section.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.PassAttributeToSection),"[password-recovery]":()=>__vitePreload(() => import('./bundled-password-recovery.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.PasswordRecovery),"[pdp-grid]":()=>__vitePreload(() => import('./bundled-pdp-grid.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.PdpGrid),"[pdp-upsell]":()=>__vitePreload(() => import('./bundled-pdp-upsell.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.PdpUpsell),"[press-carousel]":()=>__vitePreload(() => import('./bundled-press-carousel.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.PressCarousel),"[price-range]":()=>__vitePreload(() => import('./bundled-price-range.directive.js'),true?__vite__mapDeps([0]):void 0,import.meta.url).then(e=>e.PriceRange),"[price-watcher]":()=>__vitePreload(() => import('./bundled-price-watcher.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.PriceWatcher),"[product-addon]":()=>__vitePreload(() => import('./bundled-product-addon.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ProductAddon),"[product-card]":()=>__vitePreload(() => import('./bundled-product-card.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ProductCard),"[product-options]":()=>__vitePreload(() => import('./bundled-product-options.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ProductOptions),"[product-recommendations]":()=>__vitePreload(() => import('./bundled-product-recommendations.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ProductRecommendations),"[product-swatch]":()=>__vitePreload(() => import('./bundled-product-swatch.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ProductSwatch),"[product-watcher]":()=>__vitePreload(() => import('./bundled-product-watcher.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ProductWatcher),"[quantity-control]":()=>__vitePreload(() => import('./bundled-quantity-control.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.QuantityControl),"[reveal-img]":()=>__vitePreload(() => import('./bundled-reveal-img.directive.js'),true?__vite__mapDeps([5]):void 0,import.meta.url).then(e=>e.RevealImage),"[scroll-to-top]":()=>__vitePreload(() => import('./bundled-scroll-to-top.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ScrollToTop),"[scroll-top-button]":()=>__vitePreload(() => import('./bundled-scroll-top-button.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ScrollTopButton),"[scrolling-items]":()=>__vitePreload(() => import('./bundled-scrolling-items.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ScrollingItems),".searchModal":()=>__vitePreload(() => import('./bundled-searchModal.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.SearchModal),"[share-button]":()=>__vitePreload(() => import('./bundled-share-button.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ShareButton),"#OnlineStoreEditorShopifyGlobalData":()=>__vitePreload(() => import('./bundled-shopify-helper.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ShopifyHelper),".shoppableImage":()=>__vitePreload(() => import('./bundled-shoppable-image.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ShoppableImage),"[show-scroll-batch]":()=>__vitePreload(() => import('./bundled-show-scroll-batch.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ShowScrollBatch),"[show-scroll]":()=>__vitePreload(() => import('./bundled-show-scroll.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ShowScroll),"[sort-by]":()=>__vitePreload(() => import('./bundled-sort-by.directive.js'),true?__vite__mapDeps([0]):void 0,import.meta.url).then(e=>e.SortBy),".pdpHeader [data-oke-star-rating]":()=>__vitePreload(() => import('./bundled-star-rating.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.StarRating),"[sticky-atc]":()=>__vitePreload(() => import('./bundled-sticky-atc.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.StickyAtc),"[sticky-header]":()=>__vitePreload(() => import('./bundled-sticky-header.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.StickyHeader),"[tabs]":()=>__vitePreload(() => import('./bundled-tabs.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.Tabs),"[thumbnail-tooltip-option]":()=>__vitePreload(() => import('./bundled-thumbnail-tooltip-option.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ThumbnailTooltipOption),"[thumbnail-tooltip]":()=>__vitePreload(() => import('./bundled-thumbnail-tooltip.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ThumbnailTooltip),"[toggle-modal]":()=>__vitePreload(() => import('./bundled-toggle-modal.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ToggleModal),"[toggle-quick-shop]":()=>__vitePreload(() => import('./bundled-toggle-quick-shop.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ToggleQuickShop),".header__toggleSearch":()=>__vitePreload(() => import('./bundled-toggle-search.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ToggleSearch),"[video]":()=>__vitePreload(() => import('./bundled-video.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.Video),"[input-mask]":()=>__vitePreload(() => import('./bundled-input-mask.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.InputMask),"[tooltip]":()=>__vitePreload(() => import('./bundled-tooltip.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.Tooltip),"[update-sort]":()=>__vitePreload(() => import('./bundled-update-sort.directive.js'),true?__vite__mapDeps([0]):void 0,import.meta.url).then(e=>e.UpdateSort),countdown:()=>__vitePreload(() => import('./bundled-countdown.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.Countdown),"[product-inventory]":()=>__vitePreload(() => import('./bundled-product-inventory.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ProductInventory),"[product-carousel]":()=>__vitePreload(() => import('./bundled-product-carousel.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ProductCarousel),"[shipping-info]":()=>__vitePreload(() => import('./bundled-shipping-info.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ShippingInfo),"[cross-sell]":()=>__vitePreload(() => import('./bundled-cross-sell.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.CrossSell),".bundleBuilder":()=>__vitePreload(() => import('./bundled-bundle-builder.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.BundleBuilder),"hide-countdown":()=>__vitePreload(() => import('./bundled-hide-countdown.component.js'),true?[]:void 0,import.meta.url).then(e=>e.HideCountdown),"shopify-payment-terms":()=>__vitePreload(() => import('./bundled-shop-pay.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ShopPay),"[utm-promo]":()=>__vitePreload(() => import('./bundled-utm-promo.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.UTMPromo),"[add-to-bundle-quick-shop]":()=>__vitePreload(() => import('./bundled-add-to-bundle-quick-shop.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.AddToBundleQuickShop),"[cart]":()=>__vitePreload(() => import('./bundled-cart.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.Cart),"[product-sample]":()=>__vitePreload(() => import('./bundled-product-sample.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.ProductSample),".vipBanner__title":()=>__vitePreload(() => import('./bundled-vip-banner.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.VipBanner),"[user-cart]":()=>__vitePreload(() => import('./bundled-user-cart.component.js'),true?[]:void 0,import.meta.url).then(e=>e.UserCart),"[truncated-text]":()=>__vitePreload(() => import('./bundled-truncated-text.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.TruncatedText),".seoSection":()=>__vitePreload(() => import('./bundled-seo-section.directive.js'),true?[]:void 0,import.meta.url).then(e=>e.SeoSection)};

const getOffset=(t,e=document.body)=>{let r=t.getBoundingClientRect(),n=e.getBoundingClientRect(),o={left:n.left+window.scrollX,right:n.right+window.scrollX,top:n.top+window.scrollY,bottom:n.bottom+window.scrollY};return {left:r.left+window.scrollX-o.left,right:r.right+window.scrollX-o.left,top:r.top-o.top+window.scrollY,bottom:r.bottom-o.top+window.scrollY,height:r.height,width:r.width}};function Clamp(t,e,r){return t<e?e:t>r?r:t}function gearRatio(t,e,r,n,o){return (t-e)*(o-n)/(r-e)+n}function generateRdmString({length:t=8,chars:e="ABCDEFabcdef0123456789"}={}){let r="";for(let n=0;n<t;n++){let t=~~(Math.random()*e.length);r+=e.charAt(t);}return r}function escapeHtml(t){return t.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/'/g,"&quot;").replace(/'/g,"&#039;")}function findIn(t,e){let r=t.split("."),n={...e};for(let t=0;t<r.length;t++){let e=r[t];if(e in n){if(!(t<r.length-1))return n[e];n=n[e];}}}function renderIcon(e,r="string"){return "html"===r?x`<svg class="icon icon-${e}"><use xlink:href="#icon-${e}"></use></svg>`:`<svg class="icon icon-${e}"><use xlink:href="#icon-${e}"></use></svg>`}function getFocusableElements(t){return Array.from(t.querySelectorAll('a[href],button,input:not([type="hidden"]),textarea,select,details,shopify-payment-terms,[tabindex]:not([tabindex="-1"])')).filter(t=>!t.hasAttribute("disabled")&&(!t.hasAttribute("aria-hidden")||"true"!==t.getAttribute("aria-hidden"))&&!t.closest('[disable-when-empty="disabled"]'))}function createElementFromHTML(t){let e=document.createElement("div");return e.innerHTML=t.trim(),e.firstElementChild}function sanitize(t){return t?.replace(/<script(.+)?>(.*)<(.+)?\/(.+)?script(.+)?>/g,"")}function getObjProp(t,e){let r=e.split(".");for(;r.length&&(t=t[r.shift()]););return t}function dynamicListener(t,e,r,n){e.split(" ").forEach(e=>{t.addEventListener(e,t=>{t.target!==document&&t.target.matches(r)&&n(t);});});}function getParents(t,e){let r=[];for(;t&&t!==document;t=t.parentNode)t.matches(e)&&r.push(t);return r}function formToUrl(t){return new URLSearchParams(new FormData(t)).toString()}function traverseUp(t,e){let r=[],n=t;for(;n&&!n.matches(e);)r.push(n),n=n.parentElement;return r}async function digestMessage(t,e="SHA-256"){let r=new TextEncoder().encode(t);return Array.from(new Uint8Array(await crypto.subtle.digest(e,r))).map(t=>t.toString(16).padStart(2,"0")).join("")}function replaceStringVariables(t,e){for(let r in e)t=t.replace(RegExp(`{{\\s?${r}\\s?}}`,"g"),e[r].toString());return t}function padLeft(t,e,r="0"){return t.padStart(e,r)}

class Translation{static getInstance(){return Translation.instance||(Translation.instance=new Translation),Translation.instance}static get strings(){return Translation._strings||(window.translations=window.translations||[],Translation.strings=this.mergeObjs()),Translation._strings}static set strings(n){Translation._strings=n;}static expand(n,s={}){return n.split(".").reduceRight((n,s)=>({[s]:n}),s)}static mergeObjs(){let n={},s=[],e=(n,s)=>[n,s].reduce((n,s)=>Object.entries(s).reduce((n,[s,r])=>({...n,[s]:r&&"object"==typeof r?e(n[s]||{},r):r}),n),{});(window.translations||[]).forEach(n=>{let r={};for(let s in n){let a=n[s];r=e(r,Translation.expand(s,a));}s.push(r);});for(let r=0;r<s.length;r++)n=e(n,s[r]);return n}}function t$2(e,r){let a=findIn(e,Translation.strings);return a?(r&&(a=replaceStringVariables(a,r)),a.replace(/&amp;/g,"&").replace(/&lt;/g,"<").replace(/&gt;/g,">")):""}

const e$2 = {"skew-in":{from:{autoAlpha:0,y:50,skewY:5},to:{autoAlpha:1,y:0,skewY:0}},"from-top-left":{from:{autoAlpha:0,x:"-100%",y:"-100%"},to:{autoAlpha:1,x:0,y:0}},"from-top-right":{from:{autoAlpha:0,x:"100%",y:"-100%"},to:{autoAlpha:1,x:0,y:0}},"from-bottom-left":{from:{autoAlpha:0,x:"-100%",y:"100%"},to:{autoAlpha:1,x:0,y:0}},"from-bottom-right":{from:{autoAlpha:0,x:"100%",y:"100%"},to:{autoAlpha:1,x:0,y:0}},"zoom-out":{from:{autoAlpha:0,scale:1.2},to:{autoAlpha:1,scale:1,duration:3,ease:"power4.out"}},"scale-in":{from:{autoAlpha:1,scale:0},to:{autoAlpha:1,scale:1,ease:"power4.out"}}};

class ShowScrollDirector{static getInstance(){return ShowScrollDirector.instance||(ShowScrollDirector.instance=new ShowScrollDirector),ShowScrollDirector.instance}get presets(){return this._presets}generatePresets(){if(0!==Object.keys(e$2).length)for(let[t,r]of Object.entries(e$2))this.registerPreset(t,r);}registerPreset(e,t){this._presets.set(e,t);}getPreset(e){return this._presets.get(e)}constructor(){this._presets=new Map,this.generatePresets();}}

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Return a descriptor removing the value and returning a getter
 * The getter will return a .bind version of the function
 * and memoize the result against a symbol on the instance
 */
function boundMethod(target, key, descriptor) {
  var fn = descriptor.value;

  if (typeof fn !== 'function') {
    throw new TypeError("@boundMethod decorator can only be applied to methods not: ".concat(_typeof(fn)));
  } // In IE11 calling Object.defineProperty has a side-effect of evaluating the
  // getter for the property which is being replaced. This causes infinite
  // recursion and an "Out of stack space" error.


  var definingProperty = false;
  return {
    configurable: true,
    get: function get() {
      // eslint-disable-next-line no-prototype-builtins
      if (definingProperty || this === target.prototype || this.hasOwnProperty(key) || typeof fn !== 'function') {
        return fn;
      }

      var boundFn = fn.bind(this);
      definingProperty = true;
      Object.defineProperty(this, key, {
        configurable: true,
        get: function get() {
          return boundFn;
        },
        set: function set(value) {
          fn = value;
          delete this[key];
        }
      });
      definingProperty = false;
      return boundFn;
    },
    set: function set(value) {
      fn = value;
    }
  };
}
/**
 * Use boundMethod to bind all methods on the target.prototype
 */

function boundClass(target) {
  // (Using reflect to get all keys including symbols)
  var keys; // Use Reflect if exists

  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
    keys = Reflect.ownKeys(target.prototype);
  } else {
    keys = Object.getOwnPropertyNames(target.prototype); // Use symbols if support is provided

    if (typeof Object.getOwnPropertySymbols === 'function') {
      keys = keys.concat(Object.getOwnPropertySymbols(target.prototype));
    }
  }

  keys.forEach(function (key) {
    // Ignore special case target method
    if (key === 'constructor') {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(target.prototype, key); // Only methods need binding

    if (typeof descriptor.value === 'function') {
      Object.defineProperty(target.prototype, key, boundMethod(target, key, descriptor));
    }
  });
  return target;
}
function autobind() {
  if (arguments.length === 1) {
    return boundClass.apply(void 0, arguments);
  }

  return boundMethod.apply(void 0, arguments);
}

function t$1(t,e,r,a){var c,i=arguments.length,n=i<3?e:null===a?a=Object.getOwnPropertyDescriptor(e,r):a;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)n=Reflect.decorate(t,e,r,a);else for(var o=t.length-1;o>=0;o--)(c=t[o])&&(n=(i<3?c(n):i>3?c(e,r,n):c(e,r))||n);return i>3&&n&&Object.defineProperty(e,r,n),n}function e$1(t,e){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(t,e)}class SuperTracker{static getInstance(){return SuperTracker.instance||(SuperTracker.instance=new SuperTracker),SuperTracker.instance}bindEvents(){dynamicListener(document,"click pact:track","[data-tracking-category],[data-tracking-action],[data-tracking-label],[data-tracking-breadcrumb][data-tracking-breadcrumbs],.track,*",this.autoTrack),Ohm.on("supertracker:track",this.track),document.addEventListener("supertracker:track",this.onExternalTrack),window.addEventListener("beforeunload",()=>{try{window.sessionStorage.setItem("last_visited",window.location.pathname);}catch(t){}});}trackPageView(){let t=JSON.parse(document.querySelector("script[page-details]")?.textContent||"");if(!t)return;let{login_status:e,page_type:r}=t,a=`page_load_${generateRdmString({length:32})}`;this.track({event:"rgd_page_details_loaded",event_id:a,page:{login_status:e,page_type:r},_clear:!0});}onExternalTrack(t){this.track(t.detail);}autoTrack(t){if(!t.isTrusted)return;let e=t.target;if(!e.matches("button, input, a, .track")||e.hasAttribute("silent"))return;t.stopPropagation();let r={event:"rgd_button_click",location:"",click_text:`${e.innerText}`.replace(/(<([^>]+)>)/ig,"")},a=e.closest("[data-tracking-action]")||e,c=e.closest("[data-tracking-label]")||e,i=getParents(e,"[data-tracking-breadcrumbs]"),o=[];if(i.forEach(t=>{let e=`${t.getAttribute("data-tracking-breadcrumbs")}`.trim();e&&o.push(e);}),r.event=a&&a.getAttribute("data-tracking-action")||r.event,r.click_text=`${c&&c.getAttribute("data-tracking-label")||c?.getAttribute("aria-label")||r.click_text}`,r.click_text){if(r.location=o.reverse().join(">"),r.click_text=r.click_text.split("\n").join(" ").split("	").join(" ").split("\r").join("").replace(/\s+/g," "),r.click_text=r.click_text.trim().substr(0,450),e.closest("[data-tracking-ecommerce]")&&e.getAttribute("datalayer-config")){let t=JSON.parse(e.getAttribute("datalayer-config")||"{}");r.ecommerce={currency:window.Shopify.currency.active,module_type:r.location,items:[{...t,module_type:r.location}]};}e.matches("a")&&"rdg_button_click"==r.event&&(0>e.href.indexOf("http")||e.href.indexOf(window.location.host)>=0)&&0>e.href.indexOf("products/")&&(r.event="rgd_link_click"),this.track(r);}}log(...t){SuperTracker.isProduction||console.log(...t);}track(t){t.hasOwnProperty("_clear")||(t._clear=!0),this.log("Tracking click",t),t&&SuperTracker.isProduction&&window.dataLayer.push(t);}constructor(){window.dataLayer=window.dataLayer||[],this.bindEvents(),this.trackPageView();}}SuperTracker.isProduction=window?.Shopify?.theme?.role==="main",t$1([autobind,e$1("design:type",Function),e$1("design:paramtypes",["undefined"==typeof CustomEvent?Object:CustomEvent]),e$1("design:returntype",void 0)],SuperTracker.prototype,"onExternalTrack",null),t$1([autobind,e$1("design:type",Function),e$1("design:paramtypes",["undefined"==typeof Event?Object:Event]),e$1("design:returntype",void 0)],SuperTracker.prototype,"autoTrack",null),t$1([autobind,e$1("design:type",Function),e$1("design:paramtypes",["undefined"==typeof Record?Object:Record]),e$1("design:returntype",void 0)],SuperTracker.prototype,"track",null);

class UTMInterceptor{static getInstance(){return UTMInterceptor.instance||(UTMInterceptor.instance=new UTMInterceptor),UTMInterceptor.instance}get(t){return this.params[t]}getUTMParameters(){let t=new URLSearchParams(window.location.search);return {utm_id:t.get("utm_id"),utm_source:t.get("utm_source"),utm_medium:t.get("utm_medium"),utm_campaign:t.get("utm_campaign"),utm_term:t.get("utm_term"),utm_content:t.get("utm_content")}}constructor(){this.params=this.getUTMParameters();}}

/**
This regex represents a loose rule of an “image candidate string”.

@see https://html.spec.whatwg.org/multipage/images.html#srcset-attribute

An “image candidate string” roughly consists of the following:
1. Zero or more whitespace characters.
2. A non-empty URL that does not start or end with `,`.
3. Zero or more whitespace characters.
4. An optional “descriptor” that starts with a whitespace character.
5. Zero or more whitespace characters.
6. Each image candidate string is separated by a `,`.

We intentionally implement a loose rule here so that we can perform more aggressive error handling and reporting in the below code.
*/
const imageCandidateRegex = /\s*([^,]\S*[^,](?:\s+[^,]+)?)\s*(?:,|$)/;

const duplicateDescriptorCheck = (allDescriptors, value, postfix) => {
	allDescriptors[postfix] = allDescriptors[postfix] || {};
	if (allDescriptors[postfix][value]) {
		throw new Error(`No more than one image candidate is allowed for a given descriptor: ${value}${postfix}`);
	}

	allDescriptors[postfix][value] = true;
};

const fallbackDescriptorDuplicateCheck = allDescriptors => {
	if (allDescriptors.fallback) {
		throw new Error('Only one fallback image candidate is allowed');
	}

	// TODO: Use `?`.
	if (allDescriptors.x && allDescriptors.x['1']) {
		throw new Error('A fallback image is equivalent to a 1x descriptor, providing both is invalid.');
	}

	allDescriptors.fallback = true;
};

const descriptorCountCheck = (allDescriptors, currentDescriptors) => {
	if (currentDescriptors.length === 0) {
		fallbackDescriptorDuplicateCheck(allDescriptors);
	} else if (currentDescriptors.length > 1) {
		throw new Error(`Image candidate may have no more than one descriptor, found ${currentDescriptors.length}: ${currentDescriptors.join(' ')}`);
	}
};

const validDescriptorCheck = (value, postfix, descriptor) => {
	if (Number.isNaN(value)) {
		throw new TypeError(`${descriptor || value} is not a valid number`);
	}

	switch (postfix) {
		case 'w': {
			// Check that the descriptor (minus the 'w') consists only of ASCII digits
			const widthString = descriptor.slice(0, -1);
			if (!/^\d+$/.test(widthString)) {
				throw new TypeError(`Width descriptor must be a valid non-negative integer: ${descriptor}`);
			}

			if (value <= 0) {
				throw new Error('Width descriptor must be greater than zero');
			} else if (!Number.isInteger(value)) {
				throw new TypeError('Width descriptor must be an integer');
			}

			break;
		}

		case 'x': {
			// Check that the descriptor (minus the 'x') is a valid floating-point number per HTML spec
			const densityString = descriptor.slice(0, -1);

			// HTML spec: valid floating-point number cannot be Infinity or NaN
			if (!Number.isFinite(value)) {
				throw new TypeError(`Density descriptor must be a valid floating-point number: ${descriptor}`);
			}

			// Validate the string format follows HTML floating-point number rules
			// Must be: optional sign, then either (digits + optional decimal + digits) or (decimal + digits), then optional exponent
			if (!/^-?(?:\d+(?:\.\d+)?|\.\d+)(?:[eE][+-]?\d+)?$/.test(densityString)) {
				throw new TypeError(`Density descriptor must be a valid floating-point number: ${descriptor}`);
			}

			if (value <= 0) {
				throw new Error('Pixel density descriptor must be greater than zero');
			}

			break;
		}

		case 'h': {
			throw new Error('Height descriptor is no longer allowed');
		}

		default: {
			throw new Error(`Invalid srcset descriptor: ${descriptor}`);
		}
	}
};

function parseSrcset(string, {strict = false} = {}) {
	const allDescriptors = strict ? {} : undefined;

	return string
		.replace(/\r?\n/, '')
		.replace(/,\s+/, ', ')
		.split(imageCandidateRegex)
		.filter((part, index) => index % 2 === 1)
		.map(part => {
			const [url, ...descriptors] = part.trim().split(/\s+/);

			const result = {url};

			if (strict) {
				descriptorCountCheck(allDescriptors, descriptors);
			}

			for (const descriptor of descriptors) {
				const postfix = descriptor[descriptor.length - 1];
				const value = Number.parseFloat(descriptor.slice(0, -1));

				if (strict) {
					validDescriptorCheck(value, postfix, descriptor);
					duplicateDescriptorCheck(allDescriptors, value, postfix);
				}

				switch (postfix) {
					case 'w': {
						result.width = value;
						break;
					}

					case 'h': {
						result.height = value;
						break;
					}

					case 'x': {
						result.density = value;
						break;
					}

					// No default
				}
			}

			return result;
		});
}

var t,e;(e=t||(t={})).PRODUCT_CARD=".productCard",e.PRODUCT_CARD_IMAGE=".productCard__images img";class OfferCatalogGenerator{static getInstance(){return OfferCatalogGenerator.instance||(OfferCatalogGenerator.instance=new OfferCatalogGenerator),OfferCatalogGenerator.instance}parseProductCards(){this.productCards.forEach(t=>{let e;let r=t.getAttribute("datalayer-config");if(!r)return;try{e=JSON.parse(r);}catch(t){console.warn("Invalid datalayer-config JSON on product card. Skipping this card.",t);return}let a=t.querySelector(".productCard__images img"),n=this.getLargestImage(a),i={"@type":"Offer",itemOffered:{"@type":"Product",name:e.item_name,image:n},price:e.price,priceCurrency:e.currency};this.jsonLdData.itemListElement.push(i);});}getLargestImage(t){if(!t)return;let{src:e,srcset:a}=t;if(!a||a.includes("svg"))return e;let n=parseSrcset(a),i=n.filter(t=>"number"==typeof t.width),s=i.length>0?i:n;return 0===s.length?e:s.reduce((t,e)=>("number"==typeof e.width?e.width:0)>("number"==typeof t.width?t.width:0)?e:t).url||e}renderJsonLd(){if(0===this.jsonLdData.itemListElement.length)return;this.jsonLdData.numberOfItems=this.jsonLdData.itemListElement.length;let t=document.createElement("script");t.type="application/ld+json",t.text=JSON.stringify(this.jsonLdData,null,2),document.body.appendChild(t);}constructor(){this.jsonLdData={"@context":"https://schema.org","@type":"OfferCatalog",itemListElement:[]},this.productCards=document.querySelectorAll(".productCard"),this.parseProductCards(),this.renderJsonLd();}}

Translation.getInstance(), ShowScrollDirector.getInstance(), SuperTracker.getInstance(), UTMInterceptor.getInstance();
let _ = () => {
  lazyModule("Pact", lazyDirectives).then(() => {
    Ohm.bootstrap(), document.addEventListener("pact:update-module", () => {
      Ohm.getModule("Pact")?.update();
    });
  }), OfferCatalogGenerator.getInstance();
};
"interactive" === document.readyState || "complete" === document.readyState ? _() : window.addEventListener("DOMContentLoaded", _), console.log(`
Built with ❤️ by

                              $$\\
                              $$ |
$$$$$$\\   $$$$$$\\   $$$$$$$\\ $$$$$$\\
$$  __$$\\  \\____$$\\ $$  _____|\\_$$  _|
$$ /  $$ | $$$$$$$ |$$ /        $$ |
$$ |  $$ |$$  __$$ |$$ |        $$ |$$\\
$$$$$$$  |\\$$$$$$$ |\\$$$$$$$\\   \\$$$$  |$$\\
$$  ____/  \\_______| \\_______|   \\____/ \\__|
$$ |
$$ |
\\__|


careers@workwithpact.com
`);

export { Clamp as C, Deferrer as D, Ohm as O, ShowScrollDirector as S, T, __vitePreload as _, autobind as a, generateRdmString$1 as b, toHyphenCase as c, generateRdmString as d, getFocusableElements as e, formToUrl as f, getObjProp as g, lazyDirectives as h, getOffset as i, j, traverseUp as k, lazyModule as l, digestMessage as m, createElementFromHTML as n, escapeHtml as o, pluralize as p, padLeft as q, replaceStringVariables as r, sanitize as s, t$2 as t, renderIcon as u, gearRatio as v, w, x, z };
